{
  "academic-title-type.menu.title": "Typy titulov",

  "academic-title.menu.title": "Tituly",

  "activity.columns.author.label": "Autor",
  "activity.columns.event-type.label": "Typ aktivity",
  "activity.columns.message.label": "Podrobnosti",
  "activity.columns.root-id.label": "ID koreňovej agendy",
  "activity.columns.root-type.label": "Koreňová agenda",
  "activity.columns.timestamp.label": "Dátum a čas",
  "activity.entity-reference-type.option.case": "Prípad",
  "activity.entity-reference-type.option.expert-consultant": "Odborný konzultant",
  "activity.entity-reference-type.option.monitoring": "Dohľad",
  "activity.event-type.option.case-created": "Prípad vytvorený",
  "activity.event-type.option.case-deadline-canceled": "Lehota prípadu zrušená",
  "activity.event-type.option.case-deadline-completed": "Lehota prípadu splnená",
  "activity.event-type.option.case-deadline-created": "Lehota prípadu vytvorená",
  "activity.event-type.option.case-deadline-end-date-changed": "Koniec lehoty prípadu zmenený",
  "activity.event-type.option.case-deadline-expired": "Lehota prípadu uplynula",
  "activity.event-type.option.case-deadline-resumed": "Lehota prípadu obnovená",
  "activity.event-type.option.case-deadline-suspended": "Lehota prípadu prerušená",
  "activity.event-type.option.case-delegation-changed": "Zastupovanie prípadu zmenené",
  "activity.event-type.option.case-document-created": "Záznam prípadu vytvorený",
  "activity.event-type.option.case-document-sent-to-registry": "Záznam prípadu odoslaný do registratúry",
  "activity.event-type.option.case-filed-ad-acta": "Prípad založený ad acta",
  "activity.event-type.option.case-handling-forms-changed": "Spôsob vybavenia prípadu zmenený",
  "activity.event-type.option.case-opened": "Prípad otvorený",
  "activity.event-type.option.case-processor-changed": "Spracovateľ prípadu zmenený",
  "activity.event-type.option.case-reopened": "Prípad znovu otvorený",
  "activity.event-type.option.case-solver-changed": "Riešiteľ prípadu zmenený",
  "activity.event-type.option.case-submitter-eligibility-assessed": "Posúdená oprávnenosť podávateľa",
  "activity.event-type.option.case-supplement-assessed": "Posúdené doplnenie podnetu",
  "activity.event-type.option.case-supplement-response-received": "Doručená odpoveď na výzvu",
  "activity.event-type.option.case-terminated": "Prípad ukončený",
  "activity.event-type.option.case-updated": "Prípad upravený",
  "activity.event-type.option.expert-consultant-contract-created": "Zmluva odborného konzultanta vytvorená",
  "activity.event-type.option.expert-consultant-temporary-cooperation-created": "Dočasná spolupráca odborného konzultanta vytvorená",
  "activity.event-type.option.monitoring-authorization-approved": "Poverenie schválené",
  "activity.event-type.option.monitoring-deadline-canceled": "Lehota dohľadu zrušená",
  "activity.event-type.option.monitoring-deadline-completed": "Lehota dohľadu splnená",
  "activity.event-type.option.monitoring-deadline-end-date-changed": "Koniec lehoty dohľadu zmenený",
  "activity.event-type.option.monitoring-deadline-expired": "Lehota dohľadu uplynula",
  "activity.event-type.option.monitoring-document-created": "Záznam dohľadu vytvorený",
  "activity.event-type.option.monitoring-document-sent-to-registry": "Záznam dohľadu odoslaný do registratúry",
  "activity.event-type.option.monitoring-order-created": "Objednávka dohľadu vytvorená",
  "activity.event-type.option.monitoring-resumed": "Dohľad obnovený",
  "activity.event-type.option.monitoring-started": "Dohľad začatý",
  "activity.event-type.option.monitoring-suspended": "Dohľad prerušený",
  "activity.event-type.option.monitoring-terminated": "Dohľad ukončený",
  "activity.menu.title": "Aktivity",
  "activity.title": "Aktivity",

  "adacta-reason.columns.description.label": "Popis",
  "adacta-reason.columns.title.label": "Názov",
  "adacta-reason.detail.title": "Základné informácie",
  "adacta-reason.evidence.table.title": "Dôvody založenia ad acta",
  "adacta-reason.fields.description.label": "Popis",
  "adacta-reason.fields.title.label": "Názov",
  "adacta-reason.menu.title": "Dôvody založenia ad acta",
  "adacta-reason.tabs.base-info": "Základné informácie",

  "address-type.menu.title": "Typ adresy",

  "address.fields.country.label": "Štát",
  "address.fields.descriptive-number.label": "Súpisné číslo",
  "address.fields.municipality.label": "Obec",
  "address.fields.orientation-number.label": "Orientačné číslo",
  "address.fields.street.label": "Ulica",
  "address.fields.zip-code.label": "PSČ",

  "administration.menu.title": "Administrácia",
  "administration.notification.menu.title": "Notifikácie",

  "app.sidebar.settings": "Profil a nastavenia",
  "app.sidebar.user": "Používateľ",

  "audit.value.no": "Nie",
  "audit.value.yes": "Áno",

  "calendar.deadline.detail.action": "Detail lehoty",
  "calendar.deadline.detail.deadline": "Lehota",
  "calendar.deadline.detail.end": "Koniec",
  "calendar.deadline.detail.name": "Názov",
  "calendar.deadline.detail.start": "Začiatok",
  "calendar.filter.no-value": "Žiadna hodnota",
  "calendar.filter.reset": "Resetovať",
  "calendar.filters.case-state": "Stav prípadu",
  "calendar.filters.case-state.closed": "Ukončené",
  "calendar.filters.case-state.open": "Otvorené",
  "calendar.filters.close": "Zavrieť",
  "calendar.filters.deadline": "Lehota",
  "calendar.filters.deadlines": "Lehoty",
  "calendar.filters.end": "Koniec",
  "calendar.filters.monitoring": "Dohľad",
  "calendar.filters.open": "Filtre",
  "calendar.filters.pip-case": "Prípad",
  "calendar.filters.reminder": "Pripomenutie pred koncom",
  "calendar.filters.reset": "Resetovať filtre",
  "calendar.filters.start": "Začiatok",
  "calendar.filters.supervision": "Dozor",
  "calendar.filters.task-description": "Popis",
  "calendar.filters.task-type": "Typ",
  "calendar.filters.tasks": "Úlohy",
  "calendar.filters.title": "Filtre kalendára",
  "calendar.menu.label": "Kalendár",
  "calendar.task.detail.action": "Detail úlohy",
  "calendar.task.detail.assignees": "Riešitelia",
  "calendar.task.detail.created-at": "Vytvorené",
  "calendar.task.detail.description": "Popis",
  "calendar.task.detail.task": "Úloha",
  "calendar.task.detail.type": "Typ úlohy",

  "case-possible-complaint-event.breadcrumb.detail": "Udalosť",
  "case-possible-complaint-event.columns.note.label": "Poznámka",
  "case-possible-complaint-event.columns.registry-record.label": "Záznam",
  "case-possible-complaint-event.columns.type.label": "Typ udalosti",
  "case-possible-complaint-event.columns.type.option.eligibility-assessed": "Posúdenie oprávnenosti",
  "case-possible-complaint-event.columns.type.option.response-received": "Doručená odpoveď",
  "case-possible-complaint-event.columns.type.option.supplement-accepted": "Náležitosti splnené",
  "case-possible-complaint-event.columns.type.option.supplement-rejected": "Náležitosti nesplnené",
  "case-possible-complaint-event.detail.base-info": "Udalosť",
  "case-possible-complaint-event.evidence.title": "Potenciálny podnet",

  "case-proposal.agenda.monitoring": "Dohľad",
  "case-proposal.agenda.supervision": "Dozor",
  "case-proposal.approve.button": "Schvaľujem",
  "case-proposal.approve.department.label": "Útvar",
  "case-proposal.approve.group.title": "Pridelenie návrhu",
  "case-proposal.approve.lawyer.label": "Právnik",
  "case-proposal.approve.success": "Návrh bol schválený.",
  "case-proposal.approve.title": "Schváliť návrh",
  "case-proposal.create-sk-proceeding.button": "Založiť správne konanie",
  "case-proposal.decision.title": "Rozhodnutie",
  "case-proposal.fields.decided-at.label": "Dátum rozhodnutia",
  "case-proposal.fields.decided-by.label": "Rozhodol",
  "case-proposal.fields.department.label": "Útvar",
  "case-proposal.fields.law-violations.label": "Porušenia zákona",
  "case-proposal.fields.lawyer.label": "Právnik",
  "case-proposal.fields.rejection-reason.label": "Dôvod neschválenia",
  "case-proposal.fields.remedial-measures.label": "Nesplnené nápravné opatrenia",
  "case-proposal.fields.sent-at.label": "Odoslané na rozhodnutie",
  "case-proposal.fields.sent-to-sk-at.label": "Odoslané do IS SK",
  "case-proposal.fields.state.label": "Stav",
  "case-proposal.law-violations.title": "Porušenia zákona",
  "case-proposal.list.created-at": "Vytvorený",
  "case-proposal.list.decided": "Rozhodnutie",
  "case-proposal.list.detail": "Detail",
  "case-proposal.list.detail.open": "Zobraziť detail návrhu",
  "case-proposal.list.empty": "Nebol založený žiadny návrh tohto typu.",
  "case-proposal.list.error": "Návrhy sa nepodarilo načítať.",
  "case-proposal.list.new": "Nový návrh",
  "case-proposal.list.new.confirmation": "Naozaj chcete založiť nový návrh?",
  "case-proposal.list.pdf": "PDF",
  "case-proposal.list.pdf.view": "Zobraziť PDF návrhu",
  "case-proposal.list.sent-at": "Odoslaný",
  "case-proposal.list.state": "Stav",
  "case-proposal.list.type": "Typ",
  "case-proposal.read-only.case-link": "Otvoriť v prípade",
  "case-proposal.read-only.empty": "K prípadu nie je založený žiadny návrh.",
  "case-proposal.read-only.title": "Návrhy prípadu",
  "case-proposal.reject.button": "Neschvaľujem",
  "case-proposal.reject.group.title": "Neschválenie návrhu",
  "case-proposal.reject.reason.label": "Dôvod neschválenia",
  "case-proposal.reject.success": "Návrh bol neschválený.",
  "case-proposal.reject.title": "Neschváliť návrh",
  "case-proposal.remedial-measures.title": "Nápravné opatrenia",
  "case-proposal.send.button": "Odoslať návrh R/Ú",
  "case-proposal.send.confirmation": "Naozaj chcete odoslať návrh R/Ú na rozhodnutie?",
  "case-proposal.send.success": "Návrh bol odoslaný na rozhodnutie.",
  "case-proposal.send.title": "Odoslať návrh R/Ú",
  "case-proposal.sk-proceeding.empty": "K prípadu nie je evidované žiadne správne konanie.",
  "case-proposal.sk-proceeding.founded-at.label": "Založené správne konanie",
  "case-proposal.sk-proceeding.pending": "Údaje o správnom konaní z IS SK zatiaľ neprišli.",
  "case-proposal.sk-proceeding.title": "Správne konanie v IS SK",
  "case-proposal.state.option.approved": "Schválený",
  "case-proposal.state.option.not-sent": "Neodoslaný",
  "case-proposal.state.option.rejected": "Neschválený",
  "case-proposal.state.option.sent": "Odoslaný na rozhodnutie",
  "case-proposal.subjects.add": "Pridať subjekt",
  "case-proposal.subjects.description.placeholder": "Popis porušenia",
  "case-proposal.subjects.empty": "Návrh zatiaľ neobsahuje žiadny subjekt.",
  "case-proposal.subjects.title": "Subjekty návrhu",
  "case-proposal.type.option.fine-other-authority": "Návrh na uloženie pokuty inému orgánu",
  "case-proposal.type.option.proceeding": "Návrh na začatie správneho konania",
  "case-proposal.type.option.proceeding-remedial-measures": "Návrh na začatie správneho konania vo veci nesplnenia NO",

  "case.actions.append-other-contents.button.text": "Doplniť ďalší obsah podania",
  "case.actions.append-other-contents.fields.other-contents.label": "Ďalší obsah podania",
  "case.actions.append-other-contents.group.title": "Ďalší obsah podania",
  "case.actions.append-other-contents.title": "Doplniť ďalší obsah podania",
  "case.actions.append-other-contents.toast.success": "Ďalší obsah podania bol úspešne doplnený.",
  "case.actions.change-handling-forms.button.text": "Nastaviť formu vybavenia",
  "case.actions.change-handling-forms.fields.forms.label": "Formy vybavenia",
  "case.actions.change-handling-forms.forwarded.error": "Dvojica foriem musí obsahovať formu Postúpenie podania.",
  "case.actions.change-handling-forms.group.title": "Forma vybavenia prípadu",
  "case.actions.change-handling-forms.maximum.error": "Vyberte najviac dve formy vybavenia.",
  "case.actions.change-handling-forms.single.error": "Formy Priama odpoveď a Založenie ad acta musia byť vybrané samostatne.",
  "case.actions.change-handling-forms.title": "Nastaviť formu vybavenia",
  "case.actions.change-handling-forms.toast.success": "Forma vybavenia bola úspešne nastavená.",
  "case.actions.create.confirm.content": "Chcete vytvoriť nový prípad?",
  "case.actions.create.label": "TESTOVACÍ pridať nový záznam",
  "case.actions.direct-answer.button.text": "Priama odpoveď",
  "case.actions.direct-answer.fields.other-text.label": "Voľný text",
  "case.actions.direct-answer.fields.other-text.required.error": "Pre spôsob vybavenia Iné je povinný voľný text.",
  "case.actions.direct-answer.fields.processing-method.label": "Spôsob vybavenia",
  "case.actions.direct-answer.group.title": "Priama odpoveď",
  "case.actions.direct-answer.title": "Priama odpoveď",
  "case.actions.direct-answer.toast.success": "Priama odpoveď bola úspešne uložená.",
  "case.actions.file-adacta.button.text": "Založiť ad acta",
  "case.actions.file-adacta.fields.reason.label": "Dôvod založenia ad acta",
  "case.actions.file-adacta.group.title": "Založenie ad acta",
  "case.actions.file-adacta.title": "Založiť ad acta",
  "case.actions.file-adacta.toast.success": "Dôvod založenia ad acta bol úspešne uložený.",
  "case.actions.open-detail": "Detail prípadu",
  "case.actions.possible-complaint-eligibility.button.text": "Oprávnenosť podávateľa",
  "case.actions.possible-complaint-eligibility.fields.eligibility.label": "Oprávnenosť",
  "case.actions.possible-complaint-eligibility.fields.eligibility.option.eligible": "Oprávnený",
  "case.actions.possible-complaint-eligibility.fields.eligibility.option.ineligible": "Neoprávnený",
  "case.actions.possible-complaint-eligibility.fields.note.label": "Poznámka",
  "case.actions.possible-complaint-eligibility.group.title": "Oprávnenosť podávateľa",
  "case.actions.possible-complaint-eligibility.title": "Oprávnenosť podávateľa",
  "case.actions.possible-complaint-eligibility.toast.success": "Oprávnenosť podávateľa bola uložená.",
  "case.actions.possible-complaint-supplement-assessment.button.text": "Posúdenie doplnenia",
  "case.actions.possible-complaint-supplement-assessment.fields.note.label": "Poznámka",
  "case.actions.possible-complaint-supplement-assessment.fields.requirements-met.label": "Náležitosti podnetu boli splnené",
  "case.actions.possible-complaint-supplement-assessment.group.title": "Posúdenie doplnenia",
  "case.actions.possible-complaint-supplement-assessment.title": "Posúdenie doplnenia",
  "case.actions.possible-complaint-supplement-assessment.toast.success": "Posúdenie doplnenia bolo uložené.",
  "case.actions.reopen.button.text": "Znovu otvoriť prípad",
  "case.actions.reopen.confirm.content": "Chcete znovu otvoriť prípad?",
  "case.actions.reopen.title": "Znovu otvoriť prípad",
  "case.actions.reopen.toast.success": "Prípad bol úspešne znovu otvorený.",
  "case.actions.terminate.button.text": "Ukončiť prípad",
  "case.actions.terminate.fields.completion-date.label": "Dátum ukončenia prípadu",
  "case.actions.terminate.group.title": "Ukončenie prípadu",
  "case.actions.terminate.title": "Ukončiť prípad",
  "case.actions.terminate.toast.success": "Prípad bol úspešne ukončený.",
  "case.ad-acta.fields.reason.label": "Dôvod založenia ad acta",
  "case.ad-acta.group.title": "Založenie ad acta",
  "case.affected-person.group.base-info.title": "Skupina",
  "case.affected-person.group.detail.tabs.basic-info.label": "Základné údaje",
  "case.affected-person.group.fields.designation.label": "Označenie skupiny osôb",
  "case.affected-person.individual.actions.open-detail": "Detail dotknutej osoby",
  "case.affected-person.individual.actions.verify-eprehliadky.buttons.trigger.tooltip": "Načítať údaje z ePrehliadky",
  "case.affected-person.individual.actions.verify-eprehliadky.content": "Pitevné záznamy sa načítajú z ePrehliadky podľa rodného čísla dotknutej osoby.",
  "case.affected-person.individual.actions.verify-eprehliadky.title": "Načítať údaje z ePrehliadky",
  "case.affected-person.individual.actions.verify-eprehliadky.toast.success": "Údaje z ePrehliadky boli úspešne načítané.",
  "case.affected-person.individual.base-info.title": "Dotknutá osoba",
  "case.affected-person.individual.close-person.type.child": "Dieťa",
  "case.affected-person.individual.close-person.type.grandchild": "Vnuk / vnučka",
  "case.affected-person.individual.close-person.type.grandparent": "Starý rodič",
  "case.affected-person.individual.close-person.type.other": "Iná",
  "case.affected-person.individual.close-person.type.parent": "Rodič",
  "case.affected-person.individual.close-person.type.sibling": "Súrodenec",
  "case.affected-person.individual.close-person.type.spouse": "Manžel / manželka",
  "case.affected-person.individual.detail.tabs.basic-info.label": "Základné údaje",
  "case.affected-person.individual.detail.tabs.doctors.label": "Lekári",
  "case.affected-person.individual.doctor.actions.update-from-crp.buttons.trigger.tooltip": "Načítať údaje z CRP",
  "case.affected-person.individual.doctor.actions.update-from-crp.content": "Údaje o kapitujúcich lekároch a zdravotnej poisťovni sa načítajú z CRP podľa rodného čísla dotknutej osoby.",
  "case.affected-person.individual.doctor.actions.update-from-crp.title": "Načítať údaje z CRP",
  "case.affected-person.individual.doctor.actions.update-from-crp.toast.success": "Údaje z CRP boli úspešne načítané.",
  "case.affected-person.individual.doctor.columns.first-name.label": "Meno",
  "case.affected-person.individual.doctor.columns.last-name.label": "Priezvisko",
  "case.affected-person.individual.doctor.columns.medical-specialty.label": "Odbornosť",
  "case.affected-person.individual.doctor.columns.pzs-code.label": "Kód PZS",
  "case.affected-person.individual.doctor.columns.relationship-end-date.label": "Koniec vzťahu",
  "case.affected-person.individual.doctor.columns.relationship-start-date.label": "Začiatok vzťahu",
  "case.affected-person.individual.doctor.columns.rzp-code.label": "Kód ZPr",
  "case.affected-person.individual.eprehliadky.date-of-death.label": "Dátum úmrtia",
  "case.affected-person.individual.eprehliadky.dissection-performed-at.label": "Dátum a čas pitvy",
  "case.affected-person.individual.eprehliadky.title": "ePrehliadky",
  "case.affected-person.individual.eprehliadky.verified-at.label": "Naposledy overené",
  "case.affected-person.individual.eprehliadky.workplace-code.label": "Kód pracoviska",
  "case.affected-person.individual.eprehliadky.workplace-name.label": "Názov pracoviska",
  "case.affected-person.individual.fields.close-person.other-close-person.label": "Názov blízkej osoby",
  "case.affected-person.individual.fields.close-person.type.label": "Typ blízkej osoby",
  "case.affected-person.individual.fields.health-insurance-provider.label": "Zdravotná poisťovňa",
  "case.affected-person.individual.fields.name.label": "Meno",
  "case.affected-person.individual.fields.relation-to-submitter-other-description.label": "Popis iného vzťahu",
  "case.affected-person.individual.fields.relation-to-submitter.label": "Vzťah k podávateľovi",
  "case.affected-person.individual.relation.close-person": "Blízka osoba",
  "case.affected-person.individual.relation.lawyer": "Právnik",
  "case.affected-person.individual.relation.legal-guardian": "Opatrovník",
  "case.affected-person.individual.relation.legal-representative": "Zákonný zástupca",
  "case.affected-person.individual.relation.other": "Iný",
  "case.affected-person.individual.relation.self": "Podávateľ",
  "case.affected-person.individual.undefined-submitter-relation.message": "Nie je definovaný vzťah medzi podávateľom a dotknutou osobou",
  "case.audit.fields.ad-acta-reason": "Dôvod založenia ad acta",
  "case.audit.fields.anonymous": "Anonymný podávateľ",
  "case.audit.fields.authorized-authority-identification": "Identifikácia oprávneného orgánu",
  "case.audit.fields.authorized-representative": "Splnomocnený zástupca",
  "case.audit.fields.carbon-copy-recipients": "Adresáti na vedomie",
  "case.audit.fields.case": "Prípad",
  "case.audit.fields.case-delivery-date": "Dátum doručenia podania",
  "case.audit.fields.complete-submission-date": "Dátum doručenia úplného podania",
  "case.audit.fields.contact": "Korešpondenčný kontakt",
  "case.audit.fields.contact-correspondence-address": "Korešpondenčná adresa",
  "case.audit.fields.contact-correspondence-address-building-index": "Index budovy korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-country": "Štát korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-county": "Okres korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-descriptive-number": "Súpisné číslo korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-municipality": "Obec korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-municipality-part": "Časť obce korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-orientation-number": "Orientačné číslo korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-point": "Adresný bod korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-street": "Ulica korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-type": "Typ korešpondenčnej adresy",
  "case.audit.fields.contact-correspondence-address-zip-code": "PSČ korešpondenčnej adresy",
  "case.audit.fields.contact-email": "E-mail korešpondenčného kontaktu",
  "case.audit.fields.contact-phone": "Telefón korešpondenčného kontaktu",
  "case.audit.fields.cooperating-department-solvers": "Spolupracujúci riešitelia",
  "case.audit.fields.cooperating-departments": "Spolupracujúce útvary",
  "case.audit.fields.created-at": "Dátum vytvorenia",
  "case.audit.fields.created-by": "Vytvoril",
  "case.audit.fields.deleted": "Vymazaný záznam",
  "case.audit.fields.department": "Útvar",
  "case.audit.fields.department-delivery-date": "Dátum doručenia útvaru",
  "case.audit.fields.description": "Popis",
  "case.audit.fields.direct-answer": "Priama odpoveď",
  "case.audit.fields.direct-answer-other-text": "Iný text priamej odpovede",
  "case.audit.fields.direct-answer-processing-method": "Spôsob vybavenia priamej odpovede",
  "case.audit.fields.documents": "Záznamy",
  "case.audit.fields.documents-complete": "Podklady sú úplné",
  "case.audit.fields.exclusion-reason": "Dôvod vylúčenia",
  "case.audit.fields.forms": "Formy vybavovania",
  "case.audit.fields.from": "Od",
  "case.audit.fields.id": "Identifikátor",
  "case.audit.fields.initiator": "Iniciátor prípadu",
  "case.audit.fields.linked-case": "Prepojený prípad",
  "case.audit.fields.main-recipients": "Hlavní adresáti",
  "case.audit.fields.main-solvers": "Vybavujúci riešitelia",
  "case.audit.fields.main-subject": "Predmet podania",
  "case.audit.fields.modified-at": "Dátum poslednej zmeny",
  "case.audit.fields.modified-by": "Naposledy upravil",
  "case.audit.fields.monitoring": "Dohľad",
  "case.audit.fields.monitorings": "Dohľady naviazané na prípad",
  "case.audit.fields.name": "Názov prípadu",
  "case.audit.fields.number": "Číslo prípadu",
  "case.audit.fields.number-department": "Útvar spracovateľa prípadu",
  "case.audit.fields.number-order": "Poradové číslo prípadu",
  "case.audit.fields.number-year": "Rok založenia prípadu",
  "case.audit.fields.other-contents": "Ďalší obsah podania",
  "case.audit.fields.participants": "Entity naviazané na prípad",
  "case.audit.fields.processing-stage": "Štádium vybavovania",
  "case.audit.fields.registry-file": "Spis",
  "case.audit.fields.registry-record": "Registratúrny záznam",
  "case.audit.fields.related-cases": "Súvisiace prípady",
  "case.audit.fields.represented-participants": "Zastupovaní účastníci prípadu",
  "case.audit.fields.state": "Stav prípadu",
  "case.audit.fields.subject": "Subjekt účastníka",
  "case.audit.fields.supervision": "Dozor",
  "case.audit.fields.title": "Názov",
  "case.audit.fields.to": "Do",
  "case.audit.fields.type": "Typ",
  "case.audit.fields.user": "Používateľ",
  "case.columns.case-delivery-date.label": "Dátum doručenia podania",
  "case.columns.department.label": "Riešiaci útvar",
  "case.columns.forms.label": "Formy prípadu",
  "case.columns.id.label": "Id",
  "case.columns.initiator.label": "Iniciátor prípadu",
  "case.columns.main-subject.label": "Predmet podania",
  "case.columns.name.label": "Názov prípadu",
  "case.columns.number.label": "Číslo prípadu",
  "case.columns.other-contents.label": "Ďalší obsah podania",
  "case.columns.proceeding-founded-at.label": "Založené správne konanie",
  "case.columns.processing-stage.label": "Štádium vybavovania prípadu",
  "case.columns.state.label": "Stav prípadu",
  "case.content.columns.id.label": "Id",
  "case.content.evidence.table.title": "Obsah prípadu",
  "case.content.menu.label": "Obsah prípadu",
  "case.content.tabs.base-info": "Základné informácie",
  "case.cooperation.columns.deadline-duration.label": "Lehota (kalendárne dni)",
  "case.cooperation.columns.delivered-at.label": "Dátum prijatia",
  "case.cooperation.columns.delivered.label": "Doručená",
  "case.cooperation.columns.monitoring.label": "Dohľad",
  "case.cooperation.columns.request-scope.label": "Rozsah požiadavky",
  "case.cooperation.columns.subject.label": "Cieľový útvar",
  "case.cooperation.delivery.prompt.content.title": "Prijatie spolupráce",
  "case.cooperation.delivery.prompt.title": "Zaevidovať prijatie spolupráce",
  "case.cooperation.delivery.success": "Prijatie spolupráce bolo zaevidované.",
  "case.cooperation.detail.deadline-duration.label": "Lehota na poskytnutie spolupráce (kalendárne dni)",
  "case.cooperation.detail.delivered-at.label": "Dátum prijatia spolupráce",
  "case.cooperation.detail.delivered.label": "Doručená",
  "case.cooperation.detail.group.title": "Žiadosť o spoluprácu",
  "case.cooperation.detail.monitoring.label": "Dohľad",
  "case.cooperation.detail.request-scope.label": "Rozsah požiadavky",
  "case.cooperation.documents.columns.sent-at.label": "Dátum odoslania",
  "case.cooperation.documents.title": "Záznamy spolupráce",
  "case.cooperation.evidence.table.title": "Spolupráce",
  "case.cooperation.new-document": "Žiadosť o spoluprácu",
  "case.cooperation.validation.deadline-duration.required": "Lehota na poskytnutie spolupráce je povinná.",
  "case.cooperation.validation.delivered-at.required": "Dátum prijatia spolupráce je povinný.",
  "case.cooperation.validation.monitoring.required": "Dohľad je povinný.",
  "case.cooperation.validation.request-scope.required": "Rozsah požiadavky je povinný.",
  "case.detail.menu.all": "Späť na zoznam",
  "case.detail.menu.base-info": "Základné informácie",
  "case.detail.menu.cooperation": "Spolupráce",
  "case.detail.menu.deadlines": "Lehoty",
  "case.detail.menu.file": "Spis",
  "case.detail.menu.history": "História zmien",
  "case.detail.menu.monitoring": "Dohľady",
  "case.detail.menu.possible-complaint": "Potenciálny podnet",
  "case.detail.menu.proceeding": "Správne konanie",
  "case.detail.menu.record": "Záznamy",
  "case.detail.menu.related-cases": "Súvisiace prípady a konania",
  "case.detail.menu.solver": "Riešiteľ",
  "case.detail.menu.subjects": "Subjekty",
  "case.detail.menu.submission-forwarding": "Postúpenia podania",
  "case.detail.menu.supervision": "Dozory",
  "case.detail.menu.task": "Úloha",
  "case.direct-answer.fields.other-text.label": "Voľný text",
  "case.direct-answer.fields.processing-method.label": "Spôsob vybavenia",
  "case.direct-answer.group.title": "Priama odpoveď",
  "case.direct-answer.new-document": "Priama odpoveď",
  "case.direct-answer.processing-method.option.explanation": "Vysvetlenie",
  "case.direct-answer.processing-method.option.other": "Iné",
  "case.direct-answer.processing-method.option.portal-reference": "Odkaz na portál",
  "case.direct-answer.processing-method.option.procedure-recommendation": "Odporúčanie postupu",
  "case.document.columns.finalized.label": "Finalizovaný",
  "case.document.columns.label.label": "Popis",
  "case.document.columns.ris-id.label": "RIS ID",
  "case.document.columns.ris-number.label": "Číslo RIS",
  "case.document.columns.state.label": "Stav registratúrneho záznamu",
  "case.document.columns.title.label": "Názov záznamu",
  "case.document.columns.type.label": "Typ registratúrneho záznamu",
  "case.document.content.pdf-only": "Obsah tejto šablóny tvorí PDF príloha.",
  "case.document.content.template-missing": "Najprv vyberte šablónu záznamu v základných informáciách.",
  "case.document.deadline.duration.value": "{duration} ({lapseType})",
  "case.document.deadline.sync.duration.value": "{duration} ({lapseType}), stav: {recordState}",
  "case.document.deadlines.finalization.group.title": "Lehoty pri finalizácii",
  "case.document.deadlines.synchronization.group.title": "Lehoty po synchronizácii",
  "case.document.evidence.table.title": "Záznamy",
  "case.document.finalize.deadline.duration.label": "{title} ({lapseType}){recordState}",
  "case.document.finalize.deadline.duration.min.error": "Minimálne trvanie lehoty je {minDuration} ({lapseType}).",
  "case.document.finalize.deadline.fixed-duration.value": "{duration} ({lapseType}){recordState}",
  "case.document.finalize.deadlines.group.title": "Lehoty pri finalizácii",
  "case.document.finalize.sync-deadlines.group.title": "Lehoty po synchronizácii",
  "case.document.form.affected-person-individual.label": "Dotknutá osoba",
  "case.document.form.ais-number.label": "Číslo AIS",
  "case.document.form.attachments.label": "Prílohy",
  "case.document.form.carbon-copy-recipients.label": "Adresáti na vedomie",
  "case.document.form.cooperation.label": "Spolupráca",
  "case.document.form.description": "Popis záznamu",
  "case.document.form.expert-assessment.label": "Odborné posúdenie",
  "case.document.form.expert-consultant.label": "Odborný konzultant",
  "case.document.form.finalized": "Finalizovaný",
  "case.document.form.group.title": "Základné informácie",
  "case.document.form.last-synced-at.label": "Posledná úspešná synchronizácia s RIS",
  "case.document.form.main-recipients.label": "Hlavní adresáti",
  "case.document.form.monitoring.label": "Dohľad",
  "case.document.form.note.label": "Poznámka",
  "case.document.form.outgoing-document-missing": "Záznam nemá vytvorený výstupný dokument.",
  "case.document.form.recipients.group.title": "Adresáti",
  "case.document.form.ris-id.label": "RIS ID",
  "case.document.form.ris-number.label": "Číslo RIS",
  "case.document.form.source-documents.label": "Záznamy na priloženie",
  "case.document.form.state.label": "Stav registratúrneho záznamu",
  "case.document.form.supervision.label": "Dozor",
  "case.document.form.template": "Šablóna záznamu",
  "case.document.form.title": "Názov záznamu",
  "case.document.form.type.label": "Typ registratúrneho záznamu",
  "case.document.form.validation.affected-person-individual.required": "Dotknutá osoba je povinná.",
  "case.document.form.validation.cooperation.required": "Spolupráca je povinná.",
  "case.document.form.validation.expert-assessment.required": "Odborné posúdenie je povinné.",
  "case.document.form.validation.monitoring.required": "Dohľad je povinný.",
  "case.document.form.validation.recipients.overlap": "Adresát nemôže byť zároveň hlavný adresát aj adresát na vedomie.",
  "case.document.form.validation.supervision.required": "Dozor je povinný.",
  "case.document.links.columns.title": "Dokument",
  "case.document.links.create.success": "Dokument bol naviazaný.",
  "case.document.links.create.title": "Naviazať dokument",
  "case.document.links.delete.confirm": "Naozaj chcete zrušiť väzbu na dokument? Dokument sa neodstráni.",
  "case.document.links.delete.success": "Väzba na dokument bola zrušená.",
  "case.document.links.delete.title": "Zrušiť väzbu",
  "case.document.prefill.loading": "Pripravuje sa nový záznam.",
  "case.document.prefill.recipient-missing": "Niektorého adresáta záznamu sa nepodarilo predvyplniť. Skontrolujte, či má vyplnené sídlo alebo trvalý pobyt, a doplňte ho ručne.",
  "case.document.prefill.template-missing": "Šablónu záznamu sa nepodarilo predvyplniť, vyberte ju ručne.",
  "case.document.recipient-option.address-missing": "Adresát nemá vyplnené sídlo alebo trvalý pobyt.",
  "case.document.tabs.base-info": "Základné informácie",
  "case.document.tabs.content": "Obsah záznamu",
  "case.document.tabs.history": "História zmien",
  "case.document.tabs.linked-documents": "Naviazané dokumenty",
  "case.evidence.menu.all": "Všetky",
  "case.evidence.menu.ended": "Ukončené",
  "case.evidence.menu.in-progress": "Prebiehajúce",
  "case.evidence.menu.opened": "Znovuotvorené",
  "case.evidence.menu.title": "Prípady",
  "case.fields.case-delivery-date.label": "Dátum doručenia podania",
  "case.fields.completion-date.label": "Dátum ukončenia prípadu",
  "case.fields.cooperating-departments.label": "Spolupracujúce útvary",
  "case.fields.department-delivery-date.label": "Dátum doručenia útvaru",
  "case.fields.department.label": "Riešiaci útvar",
  "case.fields.documents-complete.label": "Podklady sú úplné",
  "case.fields.documents.group": "Podklady",
  "case.fields.forms.label": "Formy prípadu",
  "case.fields.initiator.label": "Iniciátor prípadu",
  "case.fields.label.label": "Názov",
  "case.fields.main-subject.label": "Predmet podania",
  "case.fields.name.generate": "Vygenerovať názov prípadu z aktuálnych dát",
  "case.fields.name.label": "Názov prípadu",
  "case.fields.number.label": "Číslo prípadu",
  "case.fields.other-contents.label": "Ďalší obsah podania",
  "case.fields.processing-stage.label": "Štádium vybavovania prípadu",
  "case.form.option.ad-acta": "Založenie ad acta",
  "case.form.option.direct-answer": "Priama odpoveď",
  "case.form.option.health-insurance-complaint": "Podnet – zdravotné poistenie",
  "case.form.option.healthcare-complaint": "Podnet – zdravotná starostlivosť",
  "case.form.option.healthcare-purchase-complaint": "Podnet – nákup zdravotnej starostlivosti",
  "case.form.option.possible-complaint": "Potenciálny podnet",
  "case.form.option.submission-forwarded": "Postúpenie podania",
  "case.form.option.supervision": "Dozor",
  "case.form.option.surveillance-investigation": "Preskúmavanie dohľadu",
  "case.initiator.option.ministry-of-health": "MZ SR",
  "case.initiator.option.ministry-of-labour": "MPSVaR SR",
  "case.initiator.option.submitter": "Podávateľ",
  "case.initiator.option.udzs": "ÚDZS",
  "case.menu.title": "Prípady",
  "case.monitoring-review.copy-documents.button.label": "Kopírovať záznamy pôvodného prípadu",
  "case.monitoring-review.copy-documents.prompt.documents.label": "Záznamy pôvodného prípadu",
  "case.monitoring-review.copy-documents.prompt.selection.title": "Výber záznamov",
  "case.monitoring-review.copy-documents.prompt.title": "Kopírovať záznamy pôvodného prípadu",
  "case.monitoring-review.copy-documents.toast.success": "Záznamy boli úspešne skopírované.",
  "case.monitoring-review.create-follow-up-case.button.label": "Vytvoriť následný dohľad",
  "case.monitoring-review.create-follow-up-case.confirm.content": "Chcete vytvoriť nový prípad s následným dohľadom?",
  "case.monitoring-review.create-follow-up-case.confirm.title": "Vytvoriť následný dohľad",
  "case.monitoring-review.create-follow-up-case.toast.success": "Následný dohľad bol úspešne vytvorený.",
  "case.monitoring-review.evaluation.option.propose-follow-up-monitoring": "Návrh na následný dohľad",
  "case.monitoring-review.evaluation.option.reject-follow-up-proposal": "Odmietnutie podnetu na následný dohľad",
  "case.monitoring-review.evaluation.placeholder": "Vybrať vyhodnotenie",
  "case.monitoring-review.evaluation.toast.success": "Vyhodnotenie bolo úspešne uložené.",
  "case.monitoring-review.fields.evaluation.label": "Vyhodnotenie návrhu na následný dohľad",
  "case.monitoring-review.fields.follow-up-case.label": "Prípad následného dohľadu",
  "case.monitoring-review.fields.follow-up-monitoring-department.label": "Útvar následného dohľadu",
  "case.monitoring-review.fields.original-case.label": "Pôvodný prípad",
  "case.monitoring-review.fields.original-monitoring.label": "Pôvodný dohľad",
  "case.monitoring-review.follow-up-monitoring-department.placeholder": "Vybrať útvar následného dohľadu",
  "case.monitoring-review.follow-up-monitoring-department.toast.success": "Útvar následného dohľadu bol úspešne uložený.",
  "case.monitoring-review.group.title": "Preskúmavanie dohľadu",
  "case.monitoring-review.new-document.order-decision": "Rozhodnutie o nariadení následného dohľadu",
  "case.monitoring-review.new-document.order-notice": "Oznámenie o nariadení následného dohľadu",
  "case.monitoring-review.new-document.proposal": "Žiadosť o vykonanie následného dohľadu",
  "case.monitoring-review.new-document.rejection": "Odmietnutie podnetu na následný dohľad",
  "case.monitoring-review.original-monitoring.placeholder": "Vybrať pôvodný dohľad",
  "case.monitoring-review.original-monitoring.toast.success": "Pôvodný dohľad bol úspešne uložený.",
  "case.monitoring.title": "Dohľady",
  "case.new-document-links.label": "Nový záznam",
  "case.policy.reason.case-ended": "Do ukončeného, zastaveného ani zrušeného prípadu nie je možné zasahovať bez jeho znovuotvorenia.",
  "case.policy.reason.case-not-terminal": "Ďalší obsah je možné doplniť iba do ukončeného, zastaveného alebo zrušeného prípadu.",
  "case.policy.reason.default": "Akcia nie je dostupná.",
  "case.policy.reason.missing-case-access": "K tomuto prípadu nemáte oprávnenie na zápis, môžete ho iba prezerať.",
  "case.policy.reason.missing-case-initiator": "Pred zmenou formy vybavenia najprv nastavte iniciátora prípadu.",
  "case.possible-complaint.fields.submitter-eligibility.label": "Oprávnenosť podávateľa",
  "case.possible-complaint.group.title": "Potenciálny podnet",
  "case.possible-complaint.new-document": "Oznámenie podávateľovi, že nie je oprávnený podať podnet",
  "case.processing-stage.option.case-evidence": "Evidencia prípadu",
  "case.processing-stage.option.ended": "Ukončený",
  "case.processing-stage.option.finalisation": "Záverovanie",
  "case.processing-stage.option.processing": "Vybavuje sa",
  "case.processing-stage.option.supervision": "Dozor",
  "case.processing-stage.option.surveillance": "Dohľad",
  "case.representative.fields.represented-participants.label": "Zastupovaní účastníci",
  "case.representative.group.title": "Splnomocnený zástupca",
  "case.sidebar.detail.open": "Otvoriť prípad",
  "case.sidebar.info.proceeding": "Správne konanie",
  "case.sidebar.info.proceeding.founded": "Založené",
  "case.sidebar.info.processing-stage": "Štádium",
  "case.sidebar.info.state": "Stav",
  "case.solver.actions.add.field.from.label": "Od",
  "case.solver.actions.add.field.type.label": "Typ riešiteľa",
  "case.solver.actions.add.field.user.label": "Používateľ",
  "case.solver.actions.update.field.exclusion-reason.label": "Dôvod vylúčenia",
  "case.solver.actions.update.field.to.label": "Do",
  "case.solver.columns.from.label": "Od",
  "case.solver.columns.id.label": "Id",
  "case.solver.columns.to.label": "Do",
  "case.solver.columns.type.label": "Typ",
  "case.solver.columns.user.label": "Používateľ",
  "case.solver.type.option.cooperative": "Spolupracujúci",
  "case.solver.type.option.main": "Vybavujúca",
  "case.state.option.ended": "Ukončený",
  "case.state.option.in-progress": "Prebiehajúci",
  "case.state.option.new": "Nový",
  "case.state.option.opened": "Znovuotvorený",
  "case.subject.columns.id.label": "Id",
  "case.subject.evidence.table.title": "Predmet prípadu",
  "case.subject.menu.label": "Predmet prípadu",
  "case.subject.tabs.base-info": "Základné informácie",
  "case.subjekt.columns.name.label": "Subjekt",
  "case.subjekt.columns.participant-type.label": "Typ",
  "case.subjekt.columns.subject-identification.identified": "Stotožnený",
  "case.subjekt.columns.subject-identification.label": "Status",
  "case.subjekt.columns.subject-identification.not-identified": "Nestotožnený",
  "case.submission-forwarding.actions.create.other-reason-text.required.error": "Pre dôvod postúpenia Iné je povinný voľný text.",
  "case.submission-forwarding.columns.other-reason-text.label": "Iný dôvod postúpenia",
  "case.submission-forwarding.columns.reason.label": "Dôvod postúpenia",
  "case.submission-forwarding.columns.recipient-subject.label": "Príjemca",
  "case.submission-forwarding.detail.group.title": "Postúpenie podania",
  "case.submission-forwarding.detail.other-reason-text.label": "Iný dôvod postúpenia",
  "case.submission-forwarding.detail.reason.label": "Dôvod postúpenia",
  "case.submission-forwarding.evidence.table.title": "Postúpenia podania",
  "case.submission-forwarding.new-document": "Postúpenie podania",
  "case.submission-forwarding.reason.option.other": "Iné",
  "case.submission-forwarding.reason.option.outside-subject-matter": "Vecná nepríslušnosť",
  "case.supervision.title": "Dozory",
  "case.tabs.base-info": "Základné informácie",
  "case.title": "Prípad",
  "case.title.all": "Všetky prípady",
  "case.title.ended": "Ukončené prípady",
  "case.title.in-progress": "Prebiehajúce prípady",
  "case.title.opened": "Znovuotvorené prípady",

  "certificate.menu.title": "Certifikáty",

  "common.web.title": "Úrad pre dohľad nad zdravotnou starostlivosťou",

  "console.menu.title": "Konzola",

  "control-agenda.completion-method.option.stopped": "Zastavený",
  "control-agenda.completion-method.option.substantiated": "Opodstatnený",
  "control-agenda.completion-method.option.unsubstantiated": "Neopodstatnený",
  "control-agenda.form.option.on-site": "Na mieste",
  "control-agenda.form.option.remote": "Na diaľku",
  "control-agenda.stop-reason.option.facts-prevent-monitoring": "Zistené skutočnosti neumožňujú vykonať dohľad",
  "control-agenda.stop-reason.option.submitter-did-not-cooperate": "Neposkytnutie súčinnosti podávateľom",
  "control-agenda.stop-reason.option.submitter-requested-stop": "Subjekt podania požiadal o zastavenie výkonu dohľadu",
  "control-agenda.stop-reason.option.submitter-requested-stop.disabled.udzs-case": "Tento dôvod nie je dostupný pre prípad iniciovaný úradom.",

  "control-result.fields.no-law-violation-found.label": "Nebolo zistené porušenie zákona",
  "control-result.title": "Porušenia zákona",

  "control.solver.columns.active-from.label": "Aktívny od",
  "control.solver.columns.active-to.label": "Aktívny do",
  "control.solver.columns.deactivation-reason.label": "Dôvod deaktivácie",
  "control.solver.columns.type.label": "Typ",
  "control.solver.columns.user.label": "Používateľ",
  "control.solver.deactivate.error": "Riešiteľa sa nepodarilo deaktivovať.",
  "control.solver.deactivate.fields.active-to.label": "Aktívny do",
  "control.solver.deactivate.fields.deactivation-reason.label": "Dôvod deaktivácie",
  "control.solver.deactivate.prompt.activeTo.error": "Dátum deaktivácie musí byť rovnaký alebo neskorší ako dátum aktivácie.",
  "control.solver.deactivate.prompt.title": "Deaktivovať riešiteľa",
  "control.solver.deactivate.success": "Riešiteľ bol úspešne deaktivovaný.",
  "control.solver.deactivate.tooltip": "Deaktivovať",
  "control.solver.evidence.table.title": "Riešitelia",
  "control.solver.fields.active-from.label": "Aktívny od",
  "control.solver.fields.active-to.label": "Aktívny do",
  "control.solver.fields.deactivation-reason.label": "Dôvod deaktivácie",
  "control.solver.fields.type.label": "Typ riešiteľa",
  "control.solver.fields.user.label": "Používateľ",
  "control.solver.tabs.base-info": "Základné informácie",
  "control.solver.type.option.main": "Vedúci riešiteľ",
  "control.solver.type.option.other": "Ostatný riešiteľ",

  "country.menu.title": "Štáty",

  "county.menu.title": "Okresy",

  "data-form.confirm-dialog.subtitle": "Túto akciu nie je možné vrátiť späť.",
  "data-form.confirm-dialog.title": "Záznam bude vymazaný",
  "data-form.delete": "Vymazať",
  "data-form.delete.error": "Záznam sa nepodarilo vymazať.",
  "data-form.submit.sucess.title": "Dáta boli úspešne vymazané.",

  "data-table.create": "Pridať nový záznam",
  "data-table.filter.date-from.label": "Od",
  "data-table.filter.date-to.label": "Do",
  "data-table.filter.placeholder": "Pridať hodnotu",

  "deadline-instance.audit.fields.deadline": "Druh lehoty",
  "deadline-instance.audit.fields.manual": "Manuálne splnenie lehoty",
  "deadline-instance.base-info.definition.title": "Definícia lehoty",
  "deadline-instance.base-info.instance.title": "Lehota",
  "deadline-instance.columns.completion-date": "Dátum splnenia",
  "deadline-instance.columns.deadline": "Lehota",
  "deadline-instance.columns.end-date": "Koniec",
  "deadline-instance.columns.start-date": "Začiatok",
  "deadline-instance.columns.state": "Stav",
  "deadline-instance.complete.button": "Splniť lehotu",
  "deadline-instance.complete.confirm": "Naozaj chcete označiť lehotu ako splnenú?",
  "deadline-instance.complete.success": "Lehota bola označená ako splnená.",
  "deadline-instance.complete.title": "Splniť lehotu",
  "deadline-instance.evidence.title": "Lehoty",
  "deadline-instance.fields.completion-date": "Dátum splnenia",
  "deadline-instance.fields.deadline": "Lehota",
  "deadline-instance.fields.duration": "Dĺžka",
  "deadline-instance.fields.end-date": "Koniec",
  "deadline-instance.fields.lapse-type": "Typ plynutia",
  "deadline-instance.fields.notification-duration": "Upozornenie pred koncom",
  "deadline-instance.fields.postal-reserve": "Vrátane poštovej rezervy",
  "deadline-instance.fields.start-date": "Začiatok",
  "deadline-instance.fields.state": "Stav",
  "deadline-instance.menu.label": "Lehoty",
  "deadline-instance.resume.confirm": "Naozaj chcete pozastavenú lehotu obnoviť?",
  "deadline-instance.resume.success": "Lehota bola obnovená.",
  "deadline-instance.resume.title": "Obnoviť lehotu",
  "deadline-instance.state.option.active": "Aktívna",
  "deadline-instance.state.option.canceled": "Zrušená",
  "deadline-instance.state.option.completed": "Splnená",
  "deadline-instance.state.option.expired": "Ukončená",
  "deadline-instance.state.option.suspended-expert-assessment": "Pozastavená pre odborné posúdenie",
  "deadline-instance.state.option.suspended-manual": "Manuálne pozastavená",
  "deadline-instance.suspend.confirm": "Naozaj chcete lehotu pozastaviť?",
  "deadline-instance.suspend.success": "Lehota bola pozastavená.",
  "deadline-instance.suspend.title": "Pozastaviť lehotu",
  "deadline-instance.tabs.base-info": "Základné informácie",
  "deadline-instance.tabs.history": "História zmien",

  "deadline.audit.fields.code": "Kód",
  "deadline.audit.fields.created-at": "Dátum vytvorenia",
  "deadline.audit.fields.created-by": "Vytvoril",
  "deadline.audit.fields.deleted": "Vymazaný záznam",
  "deadline.audit.fields.description": "Popis",
  "deadline.audit.fields.duration": "Doba trvania lehoty",
  "deadline.audit.fields.id": "Identifikátor",
  "deadline.audit.fields.lapse-type": "Typ plynutia lehoty",
  "deadline.audit.fields.modified-at": "Dátum poslednej zmeny",
  "deadline.audit.fields.modified-by": "Naposledy upravil",
  "deadline.audit.fields.notification-duration": "Doba pred koncom lehoty na odoslanie notifikácie",
  "deadline.audit.fields.postal-reserve": "Poštová rezerva",
  "deadline.audit.fields.title": "Názov",
  "deadline.audit.fields.valid-from": "Platnosť od",
  "deadline.audit.fields.valid-to": "Platnosť do",
  "deadline.columns.duration": "Dĺžka",
  "deadline.columns.lapse-type": "Typ plynutia",
  "deadline.evidence.title": "Lehoty",
  "deadline.fields.duration": "Dĺžka",
  "deadline.fields.lapse-type": "Typ plynutia",
  "deadline.fields.manual": "Manuálne splnenie lehoty",
  "deadline.fields.notification-duration": "Upozornenie pred koncom",
  "deadline.fields.postal-reserve": "Pripočítať poštovú rezervu",
  "deadline.lapse-type.notification-unit.calendar-days": "kalendárne dni",
  "deadline.lapse-type.notification-unit.months": "mesiace",
  "deadline.lapse-type.notification-unit.working-days": "pracovné dni",
  "deadline.lapse-type.option.calendar-days": "Kalendárne dni",
  "deadline.lapse-type.option.months": "Mesiace",
  "deadline.lapse-type.option.working-days": "Pracovné dni",
  "deadline.menu.label": "Lehoty",
  "deadline.suspension-reason.option.expert-assessment": "Čakanie na odborné posúdenie",
  "deadline.suspension-reason.option.manual": "Manuálne pozastavenie",
  "deadline.tabs.base-info": "Základné informácie",
  "deadline.tabs.history": "História zmien",

  "department-type.menu.title": "Typy organizačných útvarov",

  "dictionaries.group.addresses-and-territory": "Adresy a územie",
  "dictionaries.group.deadline": "Lehoty",
  "dictionaries.group.legal-assessment": "Právne posúdenie",
  "dictionaries.group.personal-and-professional-data": "Osobné a odborné údaje",
  "dictionaries.group.subjects-and-insurance": "Subjekty a poisťovne",
  "dictionaries.group.submissions-and-electronic-forms": "Podania a elektronické formuláre",
  "dictionaries.group.tasks": "Úlohy",
  "dictionaries.menu.title": "Číselníky",

  "env-managment.menu.title": "Správa prostredia",

  "expert-assessment.actions.open-detail": "Detail odborného posúdenia",
  "expert-assessment.actions.open-expert-registry": "Vyhľadať v registri súdnych znalcov",
  "expert-assessment.cancel.button": "Zrušiť odborné posúdenie",
  "expert-assessment.cancel.fields.reason": "Dôvod zrušenia",
  "expert-assessment.cancel.title": "Zrušiť odborné posúdenie",
  "expert-assessment.cancel.toast.success": "Odborné posúdenie bolo úspešne zrušené.",
  "expert-assessment.columns.consultant": "Odborný konzultant",
  "expert-assessment.columns.expert": "Súdny znalec",
  "expert-assessment.columns.kind": "Druh prizvanej osoby",
  "expert-assessment.columns.medical-specialties": "Zdravotnícke odbornosti",
  "expert-assessment.columns.state": "Stav",
  "expert-assessment.consultant-candidate.content-rating": "Obsah posudku",
  "expert-assessment.consultant-candidate.not-evaluated": "Nehodnotene",
  "expert-assessment.consultant-candidate.previously-used": "Už riešil tento prípad",
  "expert-assessment.consultant-candidate.time-rating": "Čas vybavenia",
  "expert-assessment.consultant-candidate.workload": "Vyťaženosť {value}",
  "expert-assessment.delivery.button": "Zaznamenať doručenie",
  "expert-assessment.delivery.fields.delivered-at": "Dátum doručenia",
  "expert-assessment.delivery.title": "Zaznamenať doručenie odborného posúdenia",
  "expert-assessment.delivery.toast.success": "Doručenie odborného posúdenia bolo úspešne zaznamenané.",
  "expert-assessment.detail.base-info": "Základné informácie",
  "expert-assessment.detail.menu.all": "Späť na odborné posúdenia",
  "expert-assessment.detail.menu.base-info": "Základné informácie",
  "expert-assessment.detail.menu.documents": "Záznamy",
  "expert-assessment.detail.menu.order": "Objednávka / požiadavka",
  "expert-assessment.detail.menu.ranking": "Hodnotenie",
  "expert-assessment.detail.order": "Objednávka / požiadavka",
  "expert-assessment.evidence.table.title": "Odborné posúdenia",
  "expert-assessment.fields.consultant": "Odborný konzultant",
  "expert-assessment.fields.kind": "Druh prizvanej osoby",
  "expert-assessment.fields.medical-specialties": "Zdravotnícke odbornosti",
  "expert-assessment.first-urgency.button": "Zaznamenať prvú urgenciu",
  "expert-assessment.first-urgency.fields.date": "Dátum prvej urgencie",
  "expert-assessment.first-urgency.fields.second-deadline": "Druhý termín",
  "expert-assessment.first-urgency.title": "Zaznamenať prvú urgenciu",
  "expert-assessment.first-urgency.toast.success": "Prvá urgencia bola zaznamenaná.",
  "expert-assessment.generate-documents.button": "Vygenerovať dokumenty objednávky",
  "expert-assessment.generate-documents.description": "Vygeneruje objednávku, vzor odborného stanoviska a vyúčtovanie. Predchádzajúce verzie budú nahradené.",
  "expert-assessment.generate-documents.title": "Vygenerovať dokumenty objednávky",
  "expert-assessment.generate-documents.toast.success": "Dokumenty objednávky boli vygenerované.",
  "expert-assessment.kind.expert-consultant": "Odborný konzultant",
  "expert-assessment.kind.expert-report": "Súdny znalec",
  "expert-assessment.new-document.authorization": "Poverenie odborného konzultanta",
  "expert-assessment.new-document.consultant-urgency": "Urgencia odborného konzultanta",
  "expert-assessment.new-document.opinion-request": "Žiadosť o vypracovanie odborného stanoviska",
  "expert-assessment.new-document.opinion-requirement": "Požiadavka na vypracovanie odborného stanoviska",
  "expert-assessment.new-document.opinion-supplement-request": "Žiadosť o doplnenie odborného stanoviska",
  "expert-assessment.new-document.witness-disciplinary-motion": "Podanie na MS SR – návrh na disciplinárny postih",
  "expert-assessment.new-document.witness-report-request": "Žiadosť o vypracovanie znaleckého posudku",
  "expert-assessment.new-document.witness-urgency": "Urgencia súdneho znalca",
  "expert-assessment.ranking.completion.content": "Obsahové hodnotenie",
  "expert-assessment.ranking.completion.content-description": "Vyplňte hodnotu v rozsahu 1–5.",
  "expert-assessment.ranking.completion.time": "Časové hodnotenie",
  "expert-assessment.ranking.completion.time-description": "Potvrďte predvyplnenú hodnotu alebo uveďte odôvodnenie zmeny.",
  "expert-assessment.ranking.content.title": "Obsahové hodnotenie",
  "expert-assessment.ranking.fields.content-rank": "Obsahové hodnotenie (1–5)",
  "expert-assessment.ranking.fields.content-rank-reason": "Odôvodnenie obsahového hodnotenia",
  "expert-assessment.ranking.fields.time-rank": "Časové hodnotenie (1–5)",
  "expert-assessment.ranking.fields.time-rank-reason": "Odôvodnenie časového hodnotenia",
  "expert-assessment.ranking.not-delivered": "Hodnotenie bude dostupné až po doručení odborného stanoviska.",
  "expert-assessment.ranking.time.methodology.1": "načas, do 75 % stanoveného času",
  "expert-assessment.ranking.time.methodology.2": "načas, bez 1. urgencie",
  "expert-assessment.ranking.time.methodology.3": "po 1. urgencii",
  "expert-assessment.ranking.time.methodology.4": "po 2. urgencii",
  "expert-assessment.ranking.time.methodology.5": "nedoručené po 3. termíne, zrušená objednávka",
  "expert-assessment.ranking.time.suggested": "Predvyplnené podľa termínov: {rank} – {methodology}. Pri zmene uveďte odôvodnenie.",
  "expert-assessment.ranking.time.title": "Časové hodnotenie",
  "expert-assessment.ranking.title": "Hodnotenie odborného konzultanta",
  "expert-assessment.ranking.unavailable": "Hodnotenie teraz nie je možné zobraziť.",
  "expert-assessment.second-urgency.button": "Zaznamenať druhú urgenciu",
  "expert-assessment.second-urgency.fields.date": "Dátum druhej urgencie",
  "expert-assessment.second-urgency.fields.third-deadline": "Tretí termín",
  "expert-assessment.second-urgency.title": "Zaznamenať druhú urgenciu",
  "expert-assessment.second-urgency.toast.success": "Druhá urgencia bola zaznamenaná.",
  "expert-assessment.sent.button": "Zaznamenať odoslanie",
  "expert-assessment.sent.fields.sent-date": "Dátum odoslania",
  "expert-assessment.sent.title": "Zaznamenať odoslanie",
  "expert-assessment.sent.toast.success": "Odoslanie odborného posúdenia bolo zaznamenané.",
  "expert-assessment.sidebar.info.canceled-at": "Dátum zrušenia",
  "expert-assessment.sidebar.info.delivered-at": "Dátum doručenia",
  "expert-assessment.sidebar.info.first-deadline": "1. termín",
  "expert-assessment.sidebar.info.first-urgency": "1. urgencia",
  "expert-assessment.sidebar.info.second-deadline": "2. termín",
  "expert-assessment.sidebar.info.second-urgency": "2. urgencia",
  "expert-assessment.sidebar.info.sent-date": "Dátum odoslania",
  "expert-assessment.sidebar.info.state": "Stav",
  "expert-assessment.sidebar.info.third-deadline": "3. termín",
  "expert-assessment.sidebar.info.title": "Odborné posúdenie",
  "expert-assessment.state.canceled": "Zrušené",
  "expert-assessment.state.completed": "Dokončené",
  "expert-assessment.state.in-progress": "Prebieha",
  "expert-assessment.state.new": "Nové",

  "expert-consultant.actions.open-detail": "Detail odborného konzultanta",
  "expert-consultant.activity-status.basis": "Podklad",
  "expert-consultant.activity-status.contract": "Zmluva",
  "expert-consultant.activity-status.indefinite": "na dobu neurčitú",
  "expert-consultant.activity-status.no": "Nie",
  "expert-consultant.activity-status.no-basis": "Bez platnej zmluvy ani dočasnej spolupráce",
  "expert-consultant.activity-status.temporary-cooperation": "Dočasná spolupráca",
  "expert-consultant.activity-status.title": "Stav",
  "expert-consultant.activity-status.valid-to": "do {to}",
  "expert-consultant.activity-status.validity": "od {from}, {to}",
  "expert-consultant.activity-status.yes": "Áno",
  "expert-consultant.assessment.columns.case": "Prípad",
  "expert-consultant.assessment.columns.deadline": "Aktuálny termín",
  "expert-consultant.assessment.columns.delivered-at": "Dátum doručenia",
  "expert-consultant.assessment.columns.issue-date": "Dátum vystavenia",
  "expert-consultant.assessment.columns.medical-specialties": "Odbornosti",
  "expert-consultant.assessment.columns.order-kind": "Druh",
  "expert-consultant.assessment.columns.order-number": "Číslo objednávky",
  "expert-consultant.assessment.columns.ranking": "Hodnotenie čas / obsah",
  "expert-consultant.assessment.columns.state": "Stav",
  "expert-consultant.assessment.evidence.table.title": "Odborné posúdenia",
  "expert-consultant.audit.fields.active": "Aktívny",
  "expert-consultant.audit.fields.consultant": "Konzultant",
  "expert-consultant.audit.fields.consultant-id": "Identifikátor konzultanta",
  "expert-consultant.audit.fields.consultant-record-id": "Identifikátor odborného konzultanta",
  "expert-consultant.audit.fields.contact": "Kontaktné údaje",
  "expert-consultant.audit.fields.contact-address": "Korešpondenčná adresa",
  "expert-consultant.audit.fields.contact-address-building-index": "Index budovy korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-country": "Štát korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-country-id": "Identifikátor štátu korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-county": "Okres korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-descriptive-number": "Súpisné číslo korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-municipality": "Obec korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-municipality-part": "Časť obce korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-orientation-number": "Orientačné číslo korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-point": "Adresný bod korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-street": "Ulica korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-type": "Typ korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-type-id": "Identifikátor typu korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-address-zip-code": "PSČ korešpondenčnej adresy",
  "expert-consultant.audit.fields.contact-email": "E-mail",
  "expert-consultant.audit.fields.contact-phone": "Telefón",
  "expert-consultant.audit.fields.contact-restriction": "Obmedziť oslovenie",
  "expert-consultant.audit.fields.contact-restriction-reason": "Dôvod pre obmedzenie oslovenia",
  "expert-consultant.audit.fields.contact-restriction-valid-from": "Obmedziť oslovenie od",
  "expert-consultant.audit.fields.contact-restriction-valid-to": "Obmedziť oslovenie do",
  "expert-consultant.audit.fields.content": "Dokument",
  "expert-consultant.audit.fields.content-id": "Identifikátor dokumentu",
  "expert-consultant.audit.fields.contract-record-id": "Identifikátor zmluvy",
  "expert-consultant.audit.fields.created-at": "Dátum vytvorenia",
  "expert-consultant.audit.fields.created-by": "Vytvoril",
  "expert-consultant.audit.fields.deleted": "Vymazaný záznam",
  "expert-consultant.audit.fields.do-not-contact": "Obmedziť oslovenie",
  "expert-consultant.audit.fields.medical-specialties": "Zdravotnícke odbornosti",
  "expert-consultant.audit.fields.medical-specialties-id": "Identifikátory zdravotníckych odborností",
  "expert-consultant.audit.fields.modified-at": "Dátum poslednej zmeny",
  "expert-consultant.audit.fields.modified-by": "Naposledy upravil",
  "expert-consultant.audit.fields.number": "Číslo",
  "expert-consultant.audit.fields.region": "Kraj pôsobenia",
  "expert-consultant.audit.fields.region-id": "Identifikátor kraja pôsobenia",
  "expert-consultant.audit.fields.subject": "Subjekt konzultanta",
  "expert-consultant.audit.fields.subject-id": "Identifikátor subjektu konzultanta",
  "expert-consultant.audit.fields.temporary-cooperation-record-id": "Identifikátor dočasnej spolupráce",
  "expert-consultant.audit.fields.valid-from": "Platí od",
  "expert-consultant.audit.fields.valid-to": "Platí do",
  "expert-consultant.basic-form-toolbar.save": "Uložiť",
  "expert-consultant.columns.active.label": "Aktívny",
  "expert-consultant.columns.average-content-rank.label": "Obsahové hodnotenie",
  "expert-consultant.columns.average-time-rank.label": "Časové hodnotenie",
  "expert-consultant.columns.contact-restriction.reason-missing": "Dôvod nebol uvedený.",
  "expert-consultant.columns.contact-restriction.restricted-contact.label": "Obmedziť oslovenie",
  "expert-consultant.columns.contact-restriction.restricted-contact.no": "Nie",
  "expert-consultant.columns.contact-restriction.restricted-contact.yes": "Áno",
  "expert-consultant.columns.contact.email.label": "E-mail",
  "expert-consultant.columns.contact.phone.label": "Telefón",
  "expert-consultant.columns.id.label": "Id",
  "expert-consultant.columns.medical-specialties.label": "Aktuálne aktívne odbornosti",
  "expert-consultant.columns.region.label": "Kraj pôsobenia",
  "expert-consultant.columns.subject.label": "Subjekt",
  "expert-consultant.columns.temporary-cooperation.label": "Dočasná spolupráca",
  "expert-consultant.columns.workload.label": "Vyťaženosť",
  "expert-consultant.contact-restriction.fields.do-not-contact.label": "Obmedziť oslovenie",
  "expert-consultant.contact-restriction.fields.reason.label": "Dôvod",
  "expert-consultant.contact-restriction.fields.reason.required": "Dôvod je povinný, ak sa konzultant nemá oslovovať.",
  "expert-consultant.contact-restriction.fields.valid-from.label": "Platí od",
  "expert-consultant.contact-restriction.fields.valid-to.invalid-range": "Dátum platnosti do musí byť rovnaký alebo neskorší ako dátum platnosti od.",
  "expert-consultant.contact-restriction.fields.valid-to.label": "Platí do",
  "expert-consultant.contact-restriction.form-header.title": "Obmedziť oslovenie",
  "expert-consultant.contact-restriction.group.title": "Obmedzenie kontaktu",
  "expert-consultant.contact-restriction.toast.success": "Obmedzenie kontaktu bolo úspešne uložené.",
  "expert-consultant.contract.columns.number.label": "Číslo",
  "expert-consultant.contract.columns.valid-from.label": "Platí od",
  "expert-consultant.contract.columns.valid-to.label": "Platí do",
  "expert-consultant.contract.evidence.table.title": "Zmluvy",
  "expert-consultant.contract.fields.medical-specialties.label": "Zdravotnícke odbornosti",
  "expert-consultant.contract.fields.number.label": "Číslo",
  "expert-consultant.contract.fields.valid-from.label": "Platí od",
  "expert-consultant.contract.fields.valid-to.label": "Platí do",
  "expert-consultant.contract.generate.dialog.title": "Vygenerovať zmluvu",
  "expert-consultant.contract.generate.fields.address.label": "Sídlo / trvalý pobyt",
  "expert-consultant.contract.generate.fields.bank.label": "Bankové spojenie",
  "expert-consultant.contract.generate.fields.consultant.correspondence-address.label": "Korešpondenčná adresa",
  "expert-consultant.contract.generate.fields.consultant.email.label": "E-mail",
  "expert-consultant.contract.generate.fields.consultant.medical-expertise.label": "Základná odbornosť",
  "expert-consultant.contract.generate.fields.consultant.name.label": "Celé meno",
  "expert-consultant.contract.generate.fields.consultant.phone.label": "Telefónne číslo",
  "expert-consultant.contract.generate.fields.consultant.subspecialization.label": "Subšpecializácia",
  "expert-consultant.contract.generate.fields.consultant.workplace.label": "Pracovisko",
  "expert-consultant.contract.generate.fields.contract-number.label": "Číslo zmluvy",
  "expert-consultant.contract.generate.fields.date-of-birth.label": "Dátum narodenia",
  "expert-consultant.contract.generate.fields.dic.label": "DIČ",
  "expert-consultant.contract.generate.fields.iban.label": "IBAN",
  "expert-consultant.contract.generate.fields.ico.label": "IČO",
  "expert-consultant.contract.generate.fields.name.label": "Názov / celé meno",
  "expert-consultant.contract.generate.fields.represented-by.label": "Zastúpená",
  "expert-consultant.contract.generate.groups.consultant.title": "Kontaktné údaje konzultanta",
  "expert-consultant.contract.generate.groups.legal-entity.title": "Právnická osoba",
  "expert-consultant.contract.generate.groups.natural-person.title": "Fyzická osoba",
  "expert-consultant.contract.generate.groups.subject.title": "Subjekt zmluvy",
  "expert-consultant.contract.generate.success": "Zmluva bola úspešne vygenerovaná.",
  "expert-consultant.contract.generate.toolbar.tooltip": "Vygenerovať zmluvu",
  "expert-consultant.contract.groups.document.title": "Dokument zmluvy",
  "expert-consultant.contract.tabs.base-info": "Základné informácie",
  "expert-consultant.contract.tabs.history": "História zmien",
  "expert-consultant.detail.base-info": "Základné informácie",
  "expert-consultant.detail.menu.all": "Späť na zoznam",
  "expert-consultant.detail.ranking-workload": "Hodnotenie a vyťaženosť",
  "expert-consultant.emporary-cooperation.fields.number.label": "Číslo",
  "expert-consultant.evidence.table.title": "Odborní konzultanti",
  "expert-consultant.fields.active": "Aktívny",
  "expert-consultant.fields.average-content-rank": "Obsahové hodnotenie ({count})",
  "expert-consultant.fields.average-time-rank": "Časové hodnotenie ({count})",
  "expert-consultant.fields.region": "Kraj pôsobenia",
  "expert-consultant.fields.workload": "Vyťaženosť (otvorené prípady)",
  "expert-consultant.menu.title": "Odborní konzultanti",
  "expert-consultant.tabs.assessments": "Odborné posúdenia",
  "expert-consultant.tabs.base-info": "Základné informácie",
  "expert-consultant.tabs.contact-restriction": "Obmedziť oslovenie",
  "expert-consultant.tabs.contract": "Zmluva",
  "expert-consultant.tabs.history": "História zmien",
  "expert-consultant.tabs.temporary-cooperation": "Dočasná spolupráca",
  "expert-consultant.temporary-cooperation.columns.number.label": "Číslo",
  "expert-consultant.temporary-cooperation.columns.valid-from.label": "Platí od",
  "expert-consultant.temporary-cooperation.columns.valid-to.label": "Platí do",
  "expert-consultant.temporary-cooperation.evidence.table.title": "Dočasná spolupráca",
  "expert-consultant.temporary-cooperation.fields.medical-specialties.label": "Zdravotnícke odbornosti",
  "expert-consultant.temporary-cooperation.fields.valid-from.label": "Platí od",
  "expert-consultant.temporary-cooperation.fields.valid-to.label": "Platí do",
  "expert-consultant.temporary-cooperation.tabs.base-info": "Základné informácie",
  "expert-consultant.temporary-cooperation.tabs.history": "História zmien",

  "fine.actions.open-sk-proceeding": "Otvoriť správne konanie v SK",
  "fine.actions.refetch": "Načítať znova",
  "fine.empty": "K správnemu konaniu nie je evidovaná žiadna pokuta.",
  "fine.fields.amount.label": "Výška pokuty",
  "fine.fields.imposed.no": "Pokuta nebola uložená",
  "fine.fields.imposed.yes": "Pokuta bola uložená",
  "fine.fields.legal-force-date.label": "Dátum právoplatnosti pokuty",
  "fine.fields.reason.label": "Dôvod uloženia pokuty",
  "fine.fields.state-sk.label": "Stav v SK",
  "fine.layout-group.title": "Správne konanie a pokuta",
  "fine.section.amount": "Výška pokuty",
  "fine.section.empty": "Nie je evidovaná žiadna pokuta.",
  "fine.section.legal-force-date": "Právoplatnosť",
  "fine.section.proceeding": "Správne konanie",
  "fine.section.proceeding.link": "Otvoriť v IS SK",
  "fine.section.reason": "Dôvod",
  "fine.section.state": "Stav v IS SK",
  "fine.section.title": "Pokuty",

  "form-template.phase.case-evidence": "Evidencia prípadu",
  "form-template.phase.conclusion-evidence": "Evidencia a oznamovanie záveru",
  "form-template.phase.document-collection": "Zber podkladov (podľa typu vybavovania)",
  "form-template.phase.document-familiarization": "Oboznamovanie s podkladmi",
  "form-template.phase.expert-opinion": "Zabezpečenie odborného stanoviska / posudku prizvanej osoby (dohľad)",
  "form-template.phase.finalisation": "Záverovanie",
  "form-template.phase.objections": "Námietky",
  "form-template.phase.protocol": "Protokol",
  "form-template.type.case": "Prípad",
  "form-template.type.expert-assessment": "Odborné posúdenie",
  "form-template.type.monitoring": "Dohľad",
  "form-template.type.supervision": "Dozor",

  "forms.form-submission.menu.title": "Vyplnené formuláre",
  "forms.form-template.deadlines.add": "Pridať lehotu",
  "forms.form-template.deadlines.assignment.new-title": "Nová lehota",
  "forms.form-template.deadlines.deadline.label": "Lehota",
  "forms.form-template.deadlines.detail": "Detail lehoty",
  "forms.form-template.deadlines.empty": "Šablóna nemá naviazané žiadne lehoty.",
  "forms.form-template.deadlines.record-state.label": "Stav registratúrneho záznamu",
  "forms.form-template.deadlines.remove": "Odstrániť lehotu",
  "forms.form-template.menu.title": "Šablóny formulárov",
  "forms.form-template.tabs.deadlines.label": "Lehoty",
  "forms.form-template.validation.deadline-assignments.deadline.duplicate": "Lehota je už k šablóne priradená s rovnakým stavom registratúrneho záznamu.",
  "forms.form-template.validation.deadline-assignments.deadline.required": "Lehota je povinná.",
  "forms.menu.title": "Formuláre",

  "gender.menu.title": "Pohlavie",

  "health-insurance.menu.title": "Zdravotné poisťovne",

  "home.plugin.calendar.description": "Zobrazuje kalendár udalostí na nástenke.",
  "home.plugin.calendar.title": "Kalendár",

  "law-provision.columns.law.label": "Zákon",
  "law-provision.columns.title.label": "Názov",
  "law-provision.detail.title": "Základné informácie",
  "law-provision.evidence.table.title": "Ustanovenia zákona",
  "law-provision.fields.description.label": "Popis",
  "law-provision.fields.law.label": "Zákon",
  "law-provision.fields.title.label": "Názov",
  "law-provision.menu.title": "Ustanovenia zákona",
  "law-provision.tabs.base-info": "Základné informácie",

  "law-violation-type.columns.title.label": "Názov",
  "law-violation-type.detail.title": "Základné informácie",
  "law-violation-type.evidence.table.title": "Typy porušení",
  "law-violation-type.fields.description.label": "Popis",
  "law-violation-type.fields.title.label": "Názov",
  "law-violation-type.menu.title": "Typy porušení",
  "law-violation-type.tabs.base-info": "Základné informácie",

  "law-violation.columns.law.label": "Zákon",
  "law-violation.columns.provisions.label": "Ustanovenia zákona",
  "law-violation.columns.sanctioning-subject.label": "Subjekt oprávnený uložiť sankciu",
  "law-violation.columns.types.label": "Typy porušenia",
  "law-violation.columns.violation-text.label": "Text porušenia",
  "law-violation.evidence.table.title": "Porušenia zákona",
  "law-violation.fields.law.label": "Porušený zákon",
  "law-violation.fields.provisions.label": "Porušené ustanovenia zákona",
  "law-violation.fields.sanctioning-subject-is-udzs.label": "Subjekt oprávnený uložiť sankciu je ÚDZS",
  "law-violation.fields.types.label": "Typy porušenia zákona",
  "law-violation.fields.violation-text.label": "Text porušenia",
  "law-violation.tabs.base-info": "Základné informácie",

  "law.columns.title.label": "Názov",
  "law.detail.title": "Základné informácie",
  "law.evidence.table.title": "Zákony",
  "law.fields.description.label": "Popis",
  "law.fields.title.label": "Názov",
  "law.menu.title": "Zákony",
  "law.tabs.base-info": "Základné informácie",

  "legal-form.menu.title": "Právne formy",

  "medical-specialty.menu.title": "Medicínske špecializácie",

  "monitoring-subject.actions.open-monitoring": "Otvoriť dohľad",
  "monitoring-subject.detail.tabs.basic-info.label": "Základné údaje",
  "monitoring-subject.related-monitoring.title": "Súvisiaci dohľad",

  "monitoring.actions.open-detail": "Detail dohľadu",
  "monitoring.audit.fields.case": "Nadviazaný prípad",
  "monitoring.audit.fields.category": "Kategória dohľadu",
  "monitoring.audit.fields.completion-method": "Spôsob ukončenia dohľadu",
  "monitoring.audit.fields.conclusion": "Procesné ukončenie dohľadu",
  "monitoring.audit.fields.conclusion-date": "Dátum ukončenia dohľadu",
  "monitoring.audit.fields.cooperating-subjects": "Súčinné subjekty",
  "monitoring.audit.fields.created-at": "Dátum vytvorenia",
  "monitoring.audit.fields.created-by": "Vytvoril",
  "monitoring.audit.fields.deleted": "Vymazaný záznam",
  "monitoring.audit.fields.department": "Útvar vykonávajúci dohľad",
  "monitoring.audit.fields.document-submission-date": "Dátum prevzatia alebo predloženia podkladov",
  "monitoring.audit.fields.expert-assessments": "Odborné posúdenia",
  "monitoring.audit.fields.fines": "Pokuty",
  "monitoring.audit.fields.form": "Forma dohľadu",
  "monitoring.audit.fields.healthcare-provision-form": "Forma poskytovania zdravotnej starostlivosti",
  "monitoring.audit.fields.id": "Identifikátor",
  "monitoring.audit.fields.main-solvers": "Hlavní riešitelia dohľadu",
  "monitoring.audit.fields.medical-specialties": "Medicínske odbory",
  "monitoring.audit.fields.modified-at": "Dátum poslednej zmeny",
  "monitoring.audit.fields.modified-by": "Naposledy upravil",
  "monitoring.audit.fields.monitoring-subject": "Dohliadaný subjekt",
  "monitoring.audit.fields.on-site-monitoring-date": "Dátum výkonu dohľadu na mieste",
  "monitoring.audit.fields.original-case-number": "Číslo pôvodného prípadu",
  "monitoring.audit.fields.period-from": "Dohliadané obdobie od",
  "monitoring.audit.fields.period-to": "Dohliadané obdobie do",
  "monitoring.audit.fields.previous-monitoring": "Predchádzajúci dohľad",
  "monitoring.audit.fields.protocol": "Protokol dohľadu",
  "monitoring.audit.fields.regular-termination-reason": "Dôvod riadneho ukončenia dohľadu",
  "monitoring.audit.fields.remedial-measures": "Nápravné opatrenia",
  "monitoring.audit.fields.review-case": "Prípad preskúmavania dohľadu",
  "monitoring.audit.fields.solvers": "Ostatní riešitelia dohľadu",
  "monitoring.audit.fields.start-date": "Dátum začatia",
  "monitoring.audit.fields.state": "Stav procesu dohľadu",
  "monitoring.audit.fields.stop-reason": "Dôvod ukončenia dohľadu",
  "monitoring.audit.fields.type": "Druh dohľadu",
  "monitoring.category.option.dnzs": "Dohľad nad nákupom zdravotnej starostlivosti (DNZS)",
  "monitoring.category.option.dzp": "Dohľad nad zdravotným poistením (DZP)",
  "monitoring.category.option.dzs": "Dohľad nad zdravotnou starostlivosťou (DZS)",
  "monitoring.columns.case-number.label": "Číslo prípadu",
  "monitoring.columns.category.label": "Kategória dohľadu",
  "monitoring.columns.department.label": "Zodpovedný útvar",
  "monitoring.columns.original-case-number.label": "Číslo pôvodného prípadu",
  "monitoring.columns.state.label": "Stav",
  "monitoring.columns.type.label": "Druh dohľadu",
  "monitoring.cooperating-subject.actions.mark-provided.tooltip": "Zadať prijatie súčinnosti",
  "monitoring.cooperating-subject.actions.propose-sanction.confirm.content": "Chcete navrhnúť sankciu?",
  "monitoring.cooperating-subject.actions.propose-sanction.tooltip": "Navrhnúť sankciu",
  "monitoring.cooperating-subject.actions.request-cooperation.confirm.content": "Chcete vyžiadať súčinnosť? Otvorí sa nový záznam s výzvou; stav sa zmení až po jeho uložení.",
  "monitoring.cooperating-subject.actions.request-cooperation.tooltip": "Vyžiadať súčinnosť",
  "monitoring.cooperating-subject.actions.request-supplement.confirm.content": "Chcete vyžiadať doplnenie súčinnosti? Otvorí sa nový záznam s výzvou; stav sa zmení až po jeho uložení.",
  "monitoring.cooperating-subject.actions.request-supplement.tooltip": "Vyžiadať doplnenie súčinnosti",
  "monitoring.cooperating-subject.base-info.state.title": "Súčinnosť",
  "monitoring.cooperating-subject.columns.cooperation-received-date.label": "Dátum prijatia súčinnosti",
  "monitoring.cooperating-subject.columns.cooperation-requested-date.label": "Dátum vyžiadania súčinnosti",
  "monitoring.cooperating-subject.columns.sanction-proposed-date.label": "Dátum návrhu sankcie",
  "monitoring.cooperating-subject.columns.state.label": "Stav",
  "monitoring.cooperating-subject.columns.subject.label": "Subjekt",
  "monitoring.cooperating-subject.columns.supplement-requested-date.label": "Dátum vyžiadania doplnenia",
  "monitoring.cooperating-subject.evidence.table.title": "Súčinné subjekty",
  "monitoring.cooperating-subject.fields.cooperation-provided-date.label": "Dátum poskytnutia súčinnosti",
  "monitoring.cooperating-subject.fields.cooperation-received-date.label": "Dátum prijatia súčinnosti",
  "monitoring.cooperating-subject.fields.cooperation-requested-date.label": "Dátum vyžiadania súčinnosti",
  "monitoring.cooperating-subject.fields.sanction-proposed-date.label": "Dátum návrhu sankcie",
  "monitoring.cooperating-subject.fields.state.label": "Stav",
  "monitoring.cooperating-subject.fields.supplement-requested-date.label": "Dátum vyžiadania doplnenia",
  "monitoring.cooperating-subject.provided.prompt.content.title": "Prijatie súčinnosti",
  "monitoring.cooperating-subject.provided.prompt.title": "Zadať prijatie súčinnosti",
  "monitoring.cooperating-subject.state.option.cooperation-provided": "Súčinnosť poskytnutá",
  "monitoring.cooperating-subject.state.option.cooperation-requested": "Vyžiadaná súčinnosť",
  "monitoring.cooperating-subject.state.option.created": "Vytvorený",
  "monitoring.cooperating-subject.state.option.sanction-proposed": "Navrhnutá sankcia",
  "monitoring.cooperating-subject.state.option.supplement-requested": "Vyžiadané doplnenie súčinnosti",
  "monitoring.cooperating-subject.tabs.base-info": "Základné informácie",
  "monitoring.cooperating-subject.transition.success": "Stav súčinného subjektu bol úspešne zmenený.",
  "monitoring.cooperating-subject.validation.cooperation-received-date.required": "Dátum prijatia súčinnosti je povinný.",
  "monitoring.cooperating-subject.validation.subject.already-added": "Súčinný subjekt už je k dohľadu pridaný.",
  "monitoring.cooperating-subject.validation.subject.must-be-identified": "Súčinný subjekt musí byť stotožnený.",
  "monitoring.cooperating-subject.validation.subject.required": "Súčinný subjekt je povinný.",
  "monitoring.cooperation-request.group.label": "Spolupráca iného útvaru",
  "monitoring.cooperation-request.label": "Žiadosť o spoluprácu",
  "monitoring.cooperation-request.list": "Zoznam spoluprác prípadu",
  "monitoring.deadline-extension.approve.approved-end-date.label": "Schválený dátum ukončenia",
  "monitoring.deadline-extension.approve.button": "Schváliť",
  "monitoring.deadline-extension.approve.success": "Schválenie žiadosti bolo zaznamenané.",
  "monitoring.deadline-extension.approve.title": "Zaznamenať schválenie žiadosti",
  "monitoring.deadline-extension.create.button": "Vytvoriť žiadosť o predĺženie lehoty",
  "monitoring.deadline-extension.create.group.title": "Žiadosť o predĺženie lehoty",
  "monitoring.deadline-extension.create.reason.label": "Dôvod žiadosti",
  "monitoring.deadline-extension.create.requested-end-date.label": "Navrhovaný dátum ukončenia",
  "monitoring.deadline-extension.create.requested-end-date.tooltip": "Aktuálny koniec lehoty {current}, predĺžiť ju možno najviac do {max}.",
  "monitoring.deadline-extension.create.signatory-function.label": "Funkcia podpisujúceho",
  "monitoring.deadline-extension.create.signatory-name.label": "Meno podpisujúceho",
  "monitoring.deadline-extension.create.success": "Žiadosť o predĺženie lehoty bola vytvorená.",
  "monitoring.deadline-extension.create.title": "Vytvoriť žiadosť o predĺženie lehoty",
  "monitoring.deadline-extension.history.actions": "Akcie",
  "monitoring.deadline-extension.history.decision": "Rozhodnutie",
  "monitoring.deadline-extension.history.decision.pending": "Čaká na rozhodnutie",
  "monitoring.deadline-extension.history.extension": "Predĺženie",
  "monitoring.deadline-extension.history.pdf.view": "Zobraziť PDF žiadosti",
  "monitoring.deadline-extension.history.reason": "Dôvod podania",
  "monitoring.deadline-extension.history.state": "Stav",
  "monitoring.deadline-extension.history.submitted-at": "Podané",
  "monitoring.deadline-extension.history.title": "Žiadosti o predĺženie lehoty",
  "monitoring.deadline-extension.pending.title": "Žiadosť o predĺženie lehoty",
  "monitoring.deadline-extension.reject.button": "Zamietnuť",
  "monitoring.deadline-extension.reject.confirmation": "Naozaj chcete zaznamenať zamietnutie žiadosti?",
  "monitoring.deadline-extension.reject.success": "Zamietnutie žiadosti bolo zaznamenané.",
  "monitoring.deadline-extension.reject.title": "Zaznamenať zamietnutie žiadosti",
  "monitoring.deadline-extension.state.option.approved": "Schválená",
  "monitoring.deadline-extension.state.option.pending": "Čakajúca",
  "monitoring.deadline-extension.state.option.rejected": "Zamietnutá",
  "monitoring.deadline-suspensions.history.assessment": "Odborné posúdenie",
  "monitoring.deadline-suspensions.history.end": "Koniec",
  "monitoring.deadline-suspensions.history.order": "Objednávka",
  "monitoring.deadline-suspensions.history.reason": "Dôvod",
  "monitoring.deadline-suspensions.history.start": "Začiatok",
  "monitoring.deadline-suspensions.history.title": "Pozastavenia lehoty",
  "monitoring.detail.menu.all": "Späť na zoznam",
  "monitoring.detail.menu.base-info": "Základné informácie",
  "monitoring.detail.menu.cooperating-subjects": "Súčinné subjekty",
  "monitoring.detail.menu.deadlines": "Lehoty",
  "monitoring.detail.menu.documents": "Záznamy",
  "monitoring.detail.menu.expert-assessments": "Odborné posúdenia",
  "monitoring.detail.menu.history": "História zmien",
  "monitoring.detail.menu.law-violations": "Porušenia zákona",
  "monitoring.detail.menu.proceeding": "Správne konanie",
  "monitoring.detail.menu.professional-departments": "Odborné útvary",
  "monitoring.detail.menu.protocol": "Protokol",
  "monitoring.detail.menu.remedial-measures": "Nápravné opatrenia",
  "monitoring.detail.menu.solvers": "Riešitelia",
  "monitoring.detail.menu.tasks": "Úlohy",
  "monitoring.fields.category.label": "Typ dohľadu",
  "monitoring.fields.department.label": "Zodpovedný útvar",
  "monitoring.fields.document-submission-date.label": "Dátum prevzatia/predloženia podkladov",
  "monitoring.fields.form.label": "Forma výkonu dohľadu",
  "monitoring.fields.healthcare-provision-form.label": "Forma poskytovania zdravotnej starostlivosti",
  "monitoring.fields.medical-specialties.label": "Zdravotnícke odbornosti",
  "monitoring.fields.on-site-monitoring-date.label": "Dátum výkonu dohľadu na mieste",
  "monitoring.fields.original-case-number.label": "Číslo pôvodného prípadu",
  "monitoring.fields.period-from": "Obdobie od",
  "monitoring.fields.period-from.label": "Dohliadané obdobie od",
  "monitoring.fields.period-to": "Obdobie do",
  "monitoring.fields.period-to.label": "Dohliadané obdobie do",
  "monitoring.fields.previous-monitoring.label": "Predchádzajúci riadny dohľad",
  "monitoring.fields.review-case.label": "Prípad preskúmavania dohľadu",
  "monitoring.fields.start-date.label": "Dátum začatia dohľadu",
  "monitoring.fields.state": "Stav",
  "monitoring.fields.state.label": "Stav",
  "monitoring.fields.type": "Typ",
  "monitoring.fields.type.label": "Druh dohľadu",
  "monitoring.menu.title": "Dohľady",
  "monitoring.new-document.result-notice-non-patient": "Oznámenie výsledku prešetrenia podnetu (podávateľ nie je pacient)",
  "monitoring.new-document.result-notice-patient": "Oznámenie výsledku prešetrenia podnetu (podávateľ je pacient)",
  "monitoring.new-document.stop-notice-non-patient": "Oznámenie o zastavení výkonu dohľadu (podávateľ nie je pacient)",
  "monitoring.new-document.stop-notice-patient": "Oznámenie o zastavení výkonu dohľadu (podávateľ je pacient)",
  "monitoring.policy.condition.state": "Stav dohľadu",
  "monitoring.policy.condition.subject": "Subjekt dohľadu",
  "monitoring.policy.reason.default": "Akcia nie je dostupná.",
  "monitoring.policy.reason.missing-monitoring-subject": "Najprv je potrebné zadať subjekt dohľadu.",
  "monitoring.policy.reason.monitoring-not-finished": "Dostupné až po ukončení dohľadu.",
  "monitoring.professional-departments.field.label": "Odborné útvary",
  "monitoring.protocol.fields.delivery-date.label": "Dátum doručenia",
  "monitoring.protocol.fields.document.empty": "Protokol zatiaľ nebol odoslaný dohliadanému subjektu.",
  "monitoring.protocol.fields.document.label": "Záznam v spise",
  "monitoring.protocol.fields.materials-handover-date.label": "Dátum prevzatia podkladov",
  "monitoring.protocol.fields.materials-not-taken.label": "Podklady neboli prevzaté",
  "monitoring.protocol.fields.materials-review-request.empty": "Výzva na oboznámenie sa s podkladmi zatiaľ nebola odoslaná.",
  "monitoring.protocol.fields.materials-review-request.label": "Výzva na oboznámenie sa s podkladmi",
  "monitoring.protocol.fields.minutes-receipt-date.label": "Dátum prevzatia zápisnice",
  "monitoring.protocol.fields.objection-deadline.label": "Termín podávania námietok",
  "monitoring.protocol.fields.objection-familiarization-deadline.label": "Termín oboznámenia s vyhodnotením námietok",
  "monitoring.protocol.fields.objections-received-date.label": "Dátum doručenia námietok",
  "monitoring.protocol.fields.objections-received.label": "Námietky boli doručené",
  "monitoring.protocol.fields.protocol-discussion-completed.label": "Prerokovanie prebehlo",
  "monitoring.protocol.fields.protocol-discussion-date.label": "Termín prerokovania protokolu",
  "monitoring.protocol.fields.unused-right-to-comment.label": "Nevyužité právo na vyjadrenie",
  "monitoring.protocol.group.document": "Protokol",
  "monitoring.protocol.group.materials": "Podklady pre protokol",
  "monitoring.protocol.group.objections": "Námietky",
  "monitoring.protocol.new-document.materials-review-record": "F-860 Zápisnica o oboznamovaní s podkladmi",
  "monitoring.protocol.new-document.materials-review-request": "Výzva na oboznámenie sa s podkladmi",
  "monitoring.protocol.new-document.objection-result-invitation": "Oznámenie o oboznámení s vyhodnotením námietok",
  "monitoring.protocol.new-document.objection-result-minutes": "F-138 Zápisnica o výsledku vyhodnotenia námietok",
  "monitoring.protocol.new-document.protocol-f596": "F-596 Protokol o vykonanom dohľade",
  "monitoring.protocol.new-document.protocol-substantiated": "Protokol – opodstatnený",
  "monitoring.protocol.new-document.protocol-unsubstantiated": "Protokol – neopodstatnený",
  "monitoring.regular-termination-reason.option.expired-objection-period": "Márne uplynutie lehoty na podanie písomných námietok",
  "monitoring.regular-termination-reason.option.subject-did-not-attend-result-briefing": "Dohliadaný subjekt sa nedostavil na oboznámenie s výsledkom",
  "monitoring.regular-termination-reason.option.subject-was-briefed-on-result": "Dohliadaný subjekt sa oboznámil s výsledkom",
  "monitoring.sidebar.detail.open": "Otvoriť dohľad",
  "monitoring.sidebar.detail.title": "Dohľad",
  "monitoring.solvers.copy.prompt.active-from-all.label": "Aktívni od",
  "monitoring.solvers.copy.prompt.active-from.title": "Aktivácia riešiteľov",
  "monitoring.solvers.copy.prompt.selection.title": "Výber riešiteľov",
  "monitoring.solvers.copy.prompt.solvers.label": "Riešitelia z predchádzajúceho dohľadu",
  "monitoring.solvers.copy.prompt.title": "Kopírovať riešiteľov z predchádzajúceho dohľadu",
  "monitoring.solvers.copy.success": "Riešitelia boli úspešne skopírovaní.",
  "monitoring.solvers.copy.toolbar.button": "Kopírovať z predchádzajúceho dohľadu",
  "monitoring.state.option.conclusion-process": "Záverovanie",
  "monitoring.state.option.data-review": "Oboznamovanie s podkladmi",
  "monitoring.state.option.evidence": "Evidencia dohľadu a zber podkladov",
  "monitoring.state.option.expert-opinion": "Zabezpečenie odborného posúdenia",
  "monitoring.state.option.finished": "Ukončený",
  "monitoring.state.option.protocol": "Protokol a námietky",
  "monitoring.static-layout-group.title": "Dohľad",
  "monitoring.tabs.base-info": "Základné informácie",
  "monitoring.tabs.base-info.copy-data": "Predvyplniť dáta z predchádzajúceho dohľadu",
  "monitoring.tabs.professional-departments": "Odborné útvary",
  "monitoring.termination.button": "Ukončiť dohľad",
  "monitoring.termination.fields.completion-method.label": "Spôsob ukončenia",
  "monitoring.termination.fields.conclusion-date.label": "Dátum ukončenia",
  "monitoring.termination.fields.regular-reason.label": "Dôvod riadneho ukončenia",
  "monitoring.termination.fields.stop-reason.label": "Dôvod zastavenia",
  "monitoring.termination.group.title": "Ukončenie dohľadu",
  "monitoring.termination.title": "Ukončiť dohľad",
  "monitoring.termination.toast.success": "Dohľad bol úspešne ukončený.",
  "monitoring.title": "Dohľady",
  "monitoring.type.option.disabled.unidentified-affected-person": "Pri prípade s neidentifikovanou dotknutou osobou je dostupný iba systémový dohľad.",
  "monitoring.type.option.follow-up": "Následný",
  "monitoring.type.option.regular": "Riadny",
  "monitoring.type.option.systemic": "Systémový",
  "monitoring/validation/string.required": "Povinné pole",

  "municipality-part.menu.title": "Časti obcí",

  "municipality.menu.title": "Obce",

  "notification.admin.menu.title": "Prehľad notifikácií",
  "notification.preferences.menu.label": "Nastavenia notifikácií",
  "notification.sidebar.title": "Upozornenia",
  "notification.sidebar.tooltip": "Upozornenia ({count})",
  "notification.template.menu.title": "Notifikačné šablóny",

  "notifications.delete": "Vymazať",
  "notifications.mark-all-as-read": "Označiť všetko ako prečítané",
  "notifications.mark-as-read": "Označiť ako prečítané",
  "notifications.marked-as-unread": "Označené ako neprečítané",
  "notifications.menu.title": "Notifikácie",
  "notifications.no-notifications": "Žiadne notifikácie",
  "notifications.show-all": "Zobraziť aj prečítané",

  "order.basis-hint.no-contract": "Konzultant nemá platnú zmluvu. Pri dočasnej spolupráci vystavte druh Objednávka.",
  "order.basis-hint.no-cooperation": "Konzultant nemá platnú dočasnú spoluprácu. Na základe zmluvy vystavte druh Požiadavka.",
  "order.basis-hint.none": "Konzultant nemá platnú zmluvu ani dočasnú spoluprácu, objednávku ani požiadavku preto nemožno vystaviť. Podklad doplní gestor v registri odborných konzultantov.",
  "order.basis-hint.open-consultant": "Detail konzultanta",
  "order.columns.amount-with-vat.label": "Suma s DPH",
  "order.columns.amount-without-vat.label": "Suma bez DPH",
  "order.columns.approver-function.label": "Funkcia schvaľovateľa",
  "order.columns.approver.label": "Schvaľovateľ",
  "order.columns.currency.label": "Mena",
  "order.columns.department-code.label": "Stredisko",
  "order.columns.issue-date.label": "Dátum vystavenia",
  "order.columns.kind.label": "Druh",
  "order.columns.number.label": "Číslo objednávky",
  "order.columns.subject.label": "Predmet",
  "order.columns.supplier-ico.label": "IČO",
  "order.columns.supplier-municipality.label": "Mesto",
  "order.columns.supplier-name.label": "Dodávateľ",
  "order.columns.supplier-street.label": "Ulica",
  "order.columns.supplier-zip-code.label": "PSČ",
  "order.detail.approval": "Schválenie",
  "order.detail.base-info": "Objednávka / požiadavka",
  "order.detail.registry": "Spis",
  "order.detail.supplier": "Dodávateľ",
  "order.detail.title": "Objednávka",
  "order.evidence-detail.base-info": "Základné údaje",
  "order.evidence.title": "Objednávky",
  "order.fields.amount-with-vat": "Suma s DPH",
  "order.fields.amount-without-vat": "Suma bez DPH",
  "order.fields.approval-date": "Dátum schválenia",
  "order.fields.approver": "Schvaľovateľ",
  "order.fields.approver-function": "Funkcia schvaľovateľa",
  "order.fields.approver-name": "Schvaľovateľ",
  "order.fields.approver-titles": "Tituly schvaľovateľa",
  "order.fields.basis": "Podklad",
  "order.fields.basis.contract": "Zmluva {number}",
  "order.fields.basis.temporary-cooperation": "Dočasná spolupráca {number}",
  "order.fields.contract": "Podklad – zmluva",
  "order.fields.currency": "Mena",
  "order.fields.department-code": "Stredisko",
  "order.fields.documents": "Dokumenty",
  "order.fields.first-agreed-deadline": "Prvý dohodnutý termín",
  "order.fields.generated-documents": "Vygenerované dokumenty",
  "order.fields.issue-date": "Dátum vystavenia",
  "order.fields.kind": "Druh",
  "order.fields.number": "Číslo objednávky",
  "order.fields.order-document": "Záznam objednávky",
  "order.fields.questions": "Otázky pre prizvanú osobu",
  "order.fields.subject": "Predmet",
  "order.fields.supplier-ico": "IČO",
  "order.fields.supplier-municipality": "Mesto",
  "order.fields.supplier-name": "Dodávateľ",
  "order.fields.supplier-street": "Ulica",
  "order.fields.supplier-zip-code": "PSČ",
  "order.fields.temporary-cooperation": "Podklad – dočasná spolupráca",
  "order.kind.order": "Objednávka",
  "order.kind.request": "Požiadavka",
  "order.menu.label": "Objednávky",

  "organizational-unit.detail.fields.alias.label": "Skratka",
  "organizational-unit.detail.fields.code.label": "Kód",
  "organizational-unit.detail.fields.department-type-code.label": "Kód typu útvaru",
  "organizational-unit.detail.fields.department-type.label": "Typ útvaru",
  "organizational-unit.detail.fields.description.label": "Popis",
  "organizational-unit.detail.fields.lawyer.label": "Právnik útvaru",
  "organizational-unit.detail.fields.parent-code.label": "Kód nadradeného útvaru",
  "organizational-unit.detail.fields.parent.label": "Nadradený útvar",
  "organizational-unit.detail.fields.title.label": "Názov",
  "organizational-unit.detail.groups.basic-info.title": "Základné údaje",
  "organizational-unit.detail.tabs.basic-info.label": "Základné údaje",
  "organizational-unit.evidence.table.title": "Organizačné útvary",
  "organizational-unit.menu.title": "Organizačné útvary",

  "page-404.text.description": "Ospravedlňujeme sa, ale táto stránka sa nenašla. Skontrolujte, či máte správnu adresu URL.",
  "page-404.text.title": "stránka sa nenašla",

  "page-error.401.description": "Ak chcete zobraziť túto stránku, musíte sa prihlásiť.",
  "page-error.401.title": "vyžaduje sa prihlásenie",
  "page-error.403.description": "Nemáte dostatočné oprávnenia na zobrazenie tejto stránky.",
  "page-error.403.title": "prístup zamietnutý",
  "page-error.500.description": "Skúste prihlásenie spustiť znova.",
  "page-error.500.title": "prihlásenie sa nepodarilo dokončiť",
  "page-error.button.home": "Späť na nástenku",

  "pip-task-type.audit.fields.code": "Kód",
  "pip-task-type.audit.fields.created-at": "Dátum vytvorenia",
  "pip-task-type.audit.fields.created-by": "Vytvoril",
  "pip-task-type.audit.fields.deleted": "Vymazaný záznam",
  "pip-task-type.audit.fields.description": "Popis",
  "pip-task-type.audit.fields.end-condition": "Podmienka zániku úlohy",
  "pip-task-type.audit.fields.id": "Identifikátor",
  "pip-task-type.audit.fields.modified-at": "Dátum poslednej zmeny",
  "pip-task-type.audit.fields.modified-by": "Naposledy upravil",
  "pip-task-type.audit.fields.notification-days-before-due-date": "Predvolený počet dní pred termínom na odoslanie notifikácie",
  "pip-task-type.audit.fields.notification-prefix": "Prefix v notifikáciách",
  "pip-task-type.audit.fields.start-condition": "Podmienka vzniku úlohy",
  "pip-task-type.audit.fields.title": "Názov",
  "pip-task-type.audit.fields.valid-from": "Platnosť od",
  "pip-task-type.audit.fields.valid-to": "Platnosť do",
  "pip-task-type.columns.code.label": "Kód",
  "pip-task-type.columns.description.label": "Popis",
  "pip-task-type.columns.title.label": "Názov",
  "pip-task-type.evidence.table.title": "Typy úloh",
  "pip-task-type.fields.code.label": "Kód",
  "pip-task-type.fields.description.label": "Popis",
  "pip-task-type.fields.end-condition.label": "Podmienka zániku",
  "pip-task-type.fields.notification-prefix.label": "Prefix notifikácie",
  "pip-task-type.fields.start-condition.label": "Podmienka vzniku",
  "pip-task-type.fields.title.label": "Názov",
  "pip-task-type.menu.title": "Typy úloh",
  "pip-task-type.tabs.base-info": "Základné informácie",
  "pip-task-type.tabs.history": "História zmien",

  "pip-task.actions.complete.confirm.content": "Naozaj chcete úlohu ukončiť? Ukončí sa pre všetkých jej riešiteľov.",
  "pip-task.actions.complete.toast.success": "Úloha bola ukončená.",
  "pip-task.actions.complete.toolbar.tooltip": "Ukončiť úlohu",
  "pip-task.audit.fields.assignees": "Priradení používatelia",
  "pip-task.audit.fields.case": "Prípad",
  "pip-task.audit.fields.completed": "Ukončené",
  "pip-task.audit.fields.completed-at": "Dátum a čas ukončenia",
  "pip-task.audit.fields.completed-by": "Ukončil",
  "pip-task.audit.fields.created-at": "Dátum vytvorenia",
  "pip-task.audit.fields.created-by": "Vytvoril",
  "pip-task.audit.fields.deleted": "Vymazaný záznam",
  "pip-task.audit.fields.description": "Popis",
  "pip-task.audit.fields.due-date": "Plánovaný termín realizácie úlohy",
  "pip-task.audit.fields.id": "Identifikátor",
  "pip-task.audit.fields.modified-at": "Dátum poslednej zmeny",
  "pip-task.audit.fields.modified-by": "Naposledy upravil",
  "pip-task.audit.fields.monitoring": "Dohľad",
  "pip-task.audit.fields.notification-days-before-due-date": "Počet dní pred termínom na odoslanie notifikácie",
  "pip-task.audit.fields.sent-notification-kind": "Druh odoslanej notifikácie",
  "pip-task.audit.fields.sent-notification-sent-at": "Dátum a čas odoslania notifikácie",
  "pip-task.audit.fields.sent-notifications": "Odoslané notifikácie",
  "pip-task.audit.fields.supervision": "Dozor",
  "pip-task.audit.fields.type": "Typ úlohy",
  "pip-task.columns.assignees.label": "Riešitelia",
  "pip-task.columns.completed-at.label": "Ukončené dňa",
  "pip-task.columns.completed.label": "Ukončené",
  "pip-task.columns.description.label": "Popis",
  "pip-task.columns.type.label": "Typ",
  "pip-task.evidence.table.title": "Úlohy",
  "pip-task.fields.assignees.label": "Riešitelia",
  "pip-task.fields.completed-at.label": "Ukončené dňa",
  "pip-task.fields.completed-by.label": "Ukončil",
  "pip-task.fields.completed.label": "Ukončené",
  "pip-task.fields.description.label": "Popis",
  "pip-task.fields.type.end-condition.label": "Podmienka ukončenia úlohy",
  "pip-task.fields.type.label": "Typ",
  "pip-task.menu.title": "Úlohy",
  "pip-task.messages.automatic-completion": "Túto úlohu nemôžete ukončiť ručne. Ukončí sa automaticky po splnení podmienky ukončenia.",
  "pip-task.tabs.active.label": "Aktívne",
  "pip-task.tabs.all.label": "Všetky",
  "pip-task.tabs.base-info": "Základné informácie",
  "pip-task.tabs.completed.label": "Ukončené",
  "pip-task.tabs.history": "História zmien",

  "planned-jobs.menu.title": "Plánované úlohy",

  "proceeding-proposal.blocked.title": "Správne konanie nie je možné založiť",
  "proceeding-proposal.category.option.pp": "Pokuta platiteľovi/poistencovi",
  "proceeding-proposal.category.option.zp": "Zdravotné poistenie",
  "proceeding-proposal.category.option.zs": "Zdravotná starostlivosť",
  "proceeding-proposal.fields.base.title": "Základné informácie",
  "proceeding-proposal.fields.category.label": "Druh konania",
  "proceeding-proposal.fields.category.tooltip": "Druh konania v IS SK už nie je možné zmeniť. Typ a predmet konania doplní spracovateľ v IS SK.",
  "proceeding-proposal.fields.law-provisions.label": "Ustanovenia zákona",
  "proceeding-proposal.fields.law-violation-types.label": "Typy porušení",
  "proceeding-proposal.fields.law.label": "Zákon",
  "proceeding-proposal.fields.processing-officer.label": "Spracovateľ",
  "proceeding-proposal.fields.related-cases.label": "Súvisiace prípady",
  "proceeding-proposal.fields.related-proposals.label": "Návrhy súvisiacich prípadov",
  "proceeding-proposal.fields.related-proposals.tooltip": "Za každý súvisiaci prípad sa vyberá jeden schválený návrh, z ktorého ešte nevzniklo správne konanie. Predvyplnený je najstarší.",
  "proceeding-proposal.fields.subject.derived": "Subjekt doplní systém zo schváleného návrhu.",
  "proceeding-proposal.fields.subject.label": "Subjekt",
  "proceeding-proposal.fields.subject.tooltip": "Subjekt správneho konania sa odvodzuje zo schváleného návrhu a nedá sa zmeniť.",
  "proceeding-proposal.fields.violation-text.label": "Popis porušenia",
  "proceeding-proposal.header.title": "Návrh na začatie konania {caseName}",
  "proceeding-proposal.subjects.case": "Prípad",
  "proceeding-proposal.subjects.description": "Predpokladané porušenie",
  "proceeding-proposal.subjects.empty": "Označené prípady nemajú schválený návrh so subjektmi.",
  "proceeding-proposal.subjects.subject": "Subjekt",
  "proceeding-proposal.subjects.title": "Subjekty vstupujúce do správneho konania",

  "professional-department.fields.pzs-code.label": "Kód PZS",
  "professional-department.fields.rzp-code.label": "Kód RZP",
  "professional-department.prompt.add.tooltip": "Pridať vlastný odborný útvar",
  "professional-department.prompt.title": "Pridať vlastný odborný útvar",

  "region.menu.title": "Kraje",

  "registry-file.menu.title": "Spisy",

  "registry-record.context.affected-person-individual": "Dotknutá osoba",
  "registry-record.context.case": "Prípad",
  "registry-record.context.cooperation": "Spolupráca",
  "registry-record.context.expert-assessment": "Odborné posúdenie",
  "registry-record.context.monitoring": "Dohľad",
  "registry-record.context.supervision": "Dozor",
  "registry-record.evidence.table.title": "Záznamy",
  "registry-record.finalize.dialog.title": "Finalizovať záznam",
  "registry-record.finalize.success": "Záznam bol úspešne finalizovaný.",
  "registry-record.finalize.toolbar.tooltip": "Finalizovať záznam",
  "registry-record.from-ris.redirecting": "Prebieha presmerovanie…",
  "registry-record.menu.title": "Záznamy",

  "remedial-measure-type.columns.title.label": "Názov",
  "remedial-measure-type.detail.title": "Základné informácie",
  "remedial-measure-type.evidence.table.title": "Typy nápravných opatrení",
  "remedial-measure-type.fields.description.label": "Popis",
  "remedial-measure-type.fields.title.label": "Názov",
  "remedial-measure-type.menu.title": "Typy nápravných opatrení",
  "remedial-measure-type.tabs.base-info": "Základné informácie",

  "remedial-measure.actions.fulfillment-request.button": "Výzva na splnenie NO",
  "remedial-measure.actions.proceeding-proposal.button": "Návrh na začatie SK vo veci nesplnenia NO",
  "remedial-measure.columns.acceptance-deadline.label": "Termín splnenia",
  "remedial-measure.columns.description.label": "Verejný popis",
  "remedial-measure.columns.fulfillment-quality.label": "Kvalita plnenia",
  "remedial-measure.columns.imposed-date.label": "Dátum uloženia",
  "remedial-measure.columns.type.label": "Typ",
  "remedial-measure.evidence.table.title": "Nápravné opatrenia",
  "remedial-measure.fields.acceptance-deadline.label": "Termín splnenia",
  "remedial-measure.fields.description.label": "Verejný popis",
  "remedial-measure.fields.fulfillment-date.label": "Dátum splnenia",
  "remedial-measure.fields.fulfillment-quality.label": "Kvalita plnenia",
  "remedial-measure.fields.fulfillment-scope.label": "Rozsah plnenia",
  "remedial-measure.fields.imposed-date.label": "Dátum uloženia",
  "remedial-measure.fields.type.label": "Typ",
  "remedial-measure.fulfillment-quality.option.fulfilled": "Splnené",
  "remedial-measure.fulfillment-quality.option.insufficiently-fulfilled": "Splnené nedostatočne",
  "remedial-measure.fulfillment-quality.option.not-fulfilled": "Nesplnené",
  "remedial-measure.no-remedial-measures.label": "Nebolo uložené nápravné opatrenie",
  "remedial-measure.no-remedial-measures.title": "Nápravné opatrenia",
  "remedial-measure.tabs.base-info": "Základné informácie",
  "remedial-measure.tabs.fulfillment": "Vyhodnotenie plnenia",

  "representative.detail.tabs.basic-info.label": "Základné údaje",
  "representative.detail.tabs.history.label": "História zmien",

  "restMessage.menu.title": "REST komunikácia",

  "role.menu.title": "Roly",

  "schedule.job.menu.title": "Úlohy",
  "schedule.run.menu.title": "Záznam",

  "settings.menu.title": "Používateľské nastavenia",
  "settings.profile.assignment.complaint-forms": "Typy podnetov",
  "settings.profile.assignment.complaint-forms.none": "Útvar nevybavuje podnety",
  "settings.profile.assignment.empty": "Nie ste zaradený do žiadneho útvaru.",
  "settings.profile.assignment.job-function": "Pracovná funkcia",
  "settings.profile.assignment.job-position": "Pracovné miesto",
  "settings.profile.assignment.lawyer": "Právnik útvaru",
  "settings.profile.assignment.managerial": "vedúce miesto",
  "settings.profile.assignment.parent-unit": "Nadriadený útvar",
  "settings.profile.assignment.title": "Organizačné zaradenie",
  "settings.profile.assignment.unit": "Útvar",
  "settings.profile.error": "Profil sa nepodarilo načítať.",
  "settings.profile.identity.email": "E-mail",
  "settings.profile.identity.employment": "Pracovný pomer",
  "settings.profile.identity.full-name": "Meno a priezvisko",
  "settings.profile.identity.personal-number": "Osobné číslo",
  "settings.profile.identity.source": "Zdroj účtu",
  "settings.profile.identity.source.eorg": "Organizačná štruktúra ÚDZS (EORG)",
  "settings.profile.identity.source.local": "Lokálny účet",
  "settings.profile.identity.title": "Osobné údaje",
  "settings.profile.identity.username": "Prihlasovacie meno",
  "settings.profile.menu.title": "Môj profil",
  "settings.profile.roles.empty": "Nemáte priradenú žiadnu rolu.",
  "settings.profile.roles.title": "Roly",

  "sidebar.close.subtitle": "PIP",
  "sidebar.open-menu.label": "Otvoriť menu",
  "sidebar.open.subtitle": "Podnety a iné podania",
  "sidebar.primary-items.administration": "Administrácia",
  "sidebar.primary-items.home": "Domov",

  "soapMessage.menu.title": "SOAP komunikácia",

  "solver.evidence.table.title": "Riešitelia",
  "solver.tabs.base-info": "Základné informácie",
  "solver.tabs.history": "História zmien",

  "subject.menu.label": "Subjekty",
  "subject.type.option.affected-person-group": "Dotknutá osoba - skupina",
  "subject.type.option.affected-person-individual": "Dotknutá osoba - jednotlivec",
  "subject.type.option.authorized-representative": "Zástupca",
  "subject.type.option.forwarded-subject": "Postúpený subjekt",
  "subject.type.option.monitoring-cooperating-subject": "Súčinný subjekt dohľadu",
  "subject.type.option.monitoring-subject": "Dohliadaná osoba",
  "subject.type.option.recipient": "Adresát",
  "subject.type.option.submitter": "Podávateľ",
  "subject.type.option.supervision-subject": "Dozorovaná osoba",

  "subjects.evidence.table.title": "Subjekty",
  "subjects.evidence.table.toolbar.add-subject": "Pridať subjekt",
  "subjects.evidence.table.toolbar.affected-person-group.add": "Pridať dotknutú osobu - skupinu",
  "subjects.evidence.table.toolbar.affected-person-individual.add": "Pridať dotknutú osobu - jednotlivca",
  "subjects.evidence.table.toolbar.disabled.case-evidence-stage": "Akcia je dostupná iba vo fáze Evidencia prípadu.",
  "subjects.evidence.table.toolbar.disabled.case-handling-form": "Najprv nastavte zodpovedajúcu formu vybavenia prípadu.",
  "subjects.evidence.table.toolbar.monitoring-subject.add": "Pridať dohliadanú osobu",
  "subjects.evidence.table.toolbar.representative.add": "Pridať zástupcu",
  "subjects.evidence.table.toolbar.submitter.add": "Pridať podávateľa",
  "subjects.evidence.table.toolbar.supervision-subject.add": "Pridať dozorovanú osobu",

  "submitter.detail.tabs.basic-info.label": "Základné údaje",
  "submitter.detail.tabs.history.label": "História zmien",
  "submitter.fields.anonymous.label": "Anonymný podávateľ",
  "submitter.fields.same-as-affected-person.label": "Podávateľ je zároveň dotknutou osobou",
  "submitter.group.base-info": "Základné údaje",

  "supervision-subject.actions.open-supervision": "Otvoriť dozor",
  "supervision-subject.detail.tabs.basic-info.label": "Základné údaje",
  "supervision-subject.related-supervision.title": "Súvisiaci dozor",

  "supervision.actions.open-detail": "Detail dozoru",
  "supervision.audit.fields.case": "Nadviazaný prípad",
  "supervision.audit.fields.completion-method": "Spôsob ukončenia dozoru",
  "supervision.audit.fields.conclusion": "Procesné ukončenie dozoru",
  "supervision.audit.fields.conclusion-date": "Dátum ukončenia dozoru",
  "supervision.audit.fields.created-at": "Dátum vytvorenia",
  "supervision.audit.fields.created-by": "Vytvoril",
  "supervision.audit.fields.deleted": "Vymazaný záznam",
  "supervision.audit.fields.department": "Útvar vykonávajúci dozor",
  "supervision.audit.fields.fines": "Pokuty",
  "supervision.audit.fields.form": "Forma dozoru",
  "supervision.audit.fields.id": "Identifikátor",
  "supervision.audit.fields.main-solvers": "Hlavní riešitelia dozoru",
  "supervision.audit.fields.medical-specialties": "Medicínske odbory",
  "supervision.audit.fields.modified-at": "Dátum poslednej zmeny",
  "supervision.audit.fields.modified-by": "Naposledy upravil",
  "supervision.audit.fields.monitoring-regular-termination-reason": "Dôvod riadneho ukončenia dohľadu",
  "supervision.audit.fields.period-from": "Dozorované obdobie od",
  "supervision.audit.fields.period-to": "Dozorované obdobie do",
  "supervision.audit.fields.protocol": "Protokol alebo záznam dozoru",
  "supervision.audit.fields.regular-termination-reason": "Dôvod riadneho ukončenia dozoru",
  "supervision.audit.fields.remedial-measures": "Nápravné opatrenia",
  "supervision.audit.fields.solvers": "Ostatní riešitelia dozoru",
  "supervision.audit.fields.start-date": "Dátum začatia",
  "supervision.audit.fields.state": "Stav procesu dozoru",
  "supervision.audit.fields.stop-reason": "Dôvod ukončenia dozoru",
  "supervision.audit.fields.supervision-dates": "Dátumy výkonu dozoru na mieste",
  "supervision.audit.fields.supervision-subject": "Dozorovaný subjekt",
  "supervision.audit.fields.type": "Druh dozoru",
  "supervision.columns.case-number.label": "Číslo prípadu",
  "supervision.columns.department.label": "Zodpovedný útvar",
  "supervision.columns.start-date.label": "Dátum začatia",
  "supervision.columns.state.label": "Stav",
  "supervision.columns.type.label": "Druh dozoru",
  "supervision.detail.menu.all": "Späť na zoznam",
  "supervision.detail.menu.base-info": "Základné informácie",
  "supervision.detail.menu.deadlines": "Lehoty",
  "supervision.detail.menu.documents": "Záznamy",
  "supervision.detail.menu.fines": "Pokuty",
  "supervision.detail.menu.history": "História zmien",
  "supervision.detail.menu.law-violations": "Porušenia zákona",
  "supervision.detail.menu.proceeding": "Správne konanie",
  "supervision.detail.menu.professional-departments": "Odborné útvary",
  "supervision.detail.menu.protocol": "Protokol / Záznam",
  "supervision.detail.menu.remedial-measures": "Nápravné opatrenia",
  "supervision.detail.menu.solvers": "Riešitelia",
  "supervision.detail.menu.tasks": "Úlohy",
  "supervision.fields.department.label": "Zodpovedný útvar",
  "supervision.fields.form.label": "Forma dozoru",
  "supervision.fields.period-from": "Obdobie od",
  "supervision.fields.period-from.label": "Dozorované obdobie od",
  "supervision.fields.period-to": "Obdobie do",
  "supervision.fields.period-to.label": "Dozorované obdobie do",
  "supervision.fields.start-date.label": "Dátum začatia dozoru",
  "supervision.fields.state": "Stav",
  "supervision.fields.state.label": "Stav",
  "supervision.fields.supervision-dates.add": "Pridať dátum",
  "supervision.fields.supervision-dates.empty": "Nie je zadaný žiadny dátum výkonu dozoru na mieste.",
  "supervision.fields.supervision-dates.label": "Dátumy výkonu dozoru na mieste",
  "supervision.fields.supervision-dates.remove": "Odobrať",
  "supervision.fields.type": "Typ",
  "supervision.fields.type.label": "Druh dozoru",
  "supervision.menu.title": "Dozory",
  "supervision.new-document.result-notification": "Oznámenie o výsledku prešetrenia podnetu",
  "supervision.new-document.start-notice": "Oznámenie o začatí výkonu dozoru (podávateľovi)",
  "supervision.new-document.termination-notice": "Oznámenie o zastavení výkonu dohľadu pre dohliadaný subjekt",
  "supervision.policy.condition.state": "Stav dozoru",
  "supervision.policy.condition.subject": "Subjekt dozoru",
  "supervision.policy.reason.case-ended": "Akcia nie je dostupná pri ukončenom prípade.",
  "supervision.policy.reason.default": "Akcia nie je dostupná.",
  "supervision.policy.reason.invalid-supervision-state": "Akcia nie je dostupná v aktuálnom stave dozoru.",
  "supervision.policy.reason.missing-supervision-access": "K tomuto dozoru nemáte oprávnenie na zápis, môžete ho iba prezerať.",
  "supervision.policy.reason.missing-supervision-subject": "Najprv je potrebné zadať subjekt dozoru.",
  "supervision.policy.reason.supervision-not-closed": "Dostupné až po ukončení dozoru.",
  "supervision.professional-departments.field.label": "Odborné útvary",
  "supervision.protocol.fields.delivery-date.label": "Dátum doručenia",
  "supervision.protocol.fields.document.empty": "Protokol ani záznam zatiaľ neboli odoslané dozorovanému subjektu.",
  "supervision.protocol.fields.document.label": "Záznam v spise",
  "supervision.protocol.fields.minutes-receipt-date.label": "Dátum prevzatia zápisnice",
  "supervision.protocol.fields.objection-deadline.label": "Termín podávania námietok",
  "supervision.protocol.fields.objection-familiarization-deadline.label": "Termín oboznámenia s vyhodnotením námietok",
  "supervision.protocol.fields.objections-received-date.label": "Dátum doručenia námietok",
  "supervision.protocol.fields.objections-received.label": "Námietky boli doručené",
  "supervision.protocol.fields.protocol-discussion-completed.label": "Prerokovanie prebehlo",
  "supervision.protocol.fields.protocol-discussion-date.label": "Termín prerokovania protokolu",
  "supervision.protocol.group.document": "Protokol / Záznam o výsledku dozoru",
  "supervision.protocol.group.objections": "Námietky",
  "supervision.protocol.new-document.label": "Nový dokument",
  "supervision.protocol.new-document.protocol": "F-502 Protokol o vykonaní dozoru",
  "supervision.protocol.new-document.protocol-addendum": "Dodatok k protokolu",
  "supervision.protocol.new-document.protocol-discussion-invitation": "Pozvánka na prerokovanie protokolu",
  "supervision.protocol.new-document.protocol-discussion-minutes": "Zápisnica o prerokovaní protokolu o vykonaní dozoru",
  "supervision.protocol.new-document.result-record": "F-852 Záznam o výsledku dozoru",
  "supervision.protocol.new-document.unsubstantiated-objections-notice": "Oznámenie o neopodstatnenosti námietok (F)",
  "supervision.regular-termination-reason.option.protocol-discussion-held": "Deň prerokovania protokolu",
  "supervision.regular-termination-reason.option.record-delivered": "Doručenie záznamu dozorovanému subjektu",
  "supervision.regular-termination-reason.option.subject-unexcused-absence": "Deň určený na prerokovanie protokolu, ak sa dozorovaný subjekt bezdôvodne nedostavil",
  "supervision.regular-termination.button": "Riadne ukončiť dozor",
  "supervision.regular-termination.fields.date.label": "Dátum ukončenia",
  "supervision.regular-termination.fields.reason.label": "Dôvod riadneho ukončenia",
  "supervision.regular-termination.group.title": "Riadne ukončenie dozoru",
  "supervision.regular-termination.title": "Riadne ukončiť dozor",
  "supervision.regular-termination.toast.success": "Dozor bol úspešne ukončený.",
  "supervision.sidebar.info.state": "Stav",
  "supervision.sidebar.info.title": "Prehľad",
  "supervision.state.option.closed": "Uzavretý",
  "supervision.state.option.conclusion": "Záverovanie",
  "supervision.state.option.data-review": "Oboznamovanie s podkladmi",
  "supervision.state.option.evidence": "Evidencia dozoru a zber podkladov",
  "supervision.state.option.protocol": "Protokol a námietky",
  "supervision.static-layout-group.title": "Dozor",
  "supervision.tabs.base-info": "Základné informácie",
  "supervision.tabs.professional-departments": "Odborné útvary",
  "supervision.title": "Dozory",
  "supervision.type.option.control-activity-plan": "Plán kontrolnej činnosti",
  "supervision.type.option.from-submission": "Z podania",
  "supervision.type.option.own-activity": "Vlastná činnosť",

  "test-scenario.catalog.missing": "Postup nie je v exporte",
  "test-scenario.catalog.missing-count": "Bez zdrojového postupu: {count} TC.",
  "test-scenario.catalog.preparation": "Príprava: {preparation}",
  "test-scenario.catalog.role": "Rola: {roles}",
  "test-scenario.catalog.summary": "UC/TC: {tcCount} | E2E: {e2eCount}. Lokálna príprava vytvára iba predpoklady, nie kroky scenára.",
  "test-scenario.coverage.e2e": "E2E",
  "test-scenario.detail.action": "Akcia",
  "test-scenario.detail.back": "Späť na zoznam",
  "test-scenario.detail.expected": "Očakávaný výsledok",
  "test-scenario.detail.fixtures": "Pripravené záznamy",
  "test-scenario.detail.missing": "Testovací prípad nemá zdrojové inštrukcie.",
  "test-scenario.detail.no-steps": "Zdroj neobsahuje žiadne kroky.",
  "test-scenario.detail.notes": "Príprava ({preparation}) a upozornenia",
  "test-scenario.detail.preconditions": "Predpoklady",
  "test-scenario.detail.preparing": "Pripravujem nové lokálne dáta...",
  "test-scenario.detail.retry": "Znova pripraviť nové dáta",
  "test-scenario.detail.role": "Rola:",
  "test-scenario.detail.step-satisfied": "Krok {number} je splnený prerekvizitami – príprava ho už vykonala, nevykonávajte ho.",
  "test-scenario.detail.step-satisfied-pending": "Tento krok splní príprava dát (prerekvizity); po príprave ho nevykonávajte.",
  "test-scenario.detail.steps": "Kroky",
  "test-scenario.e2e.coverage": "Zdrojová procesná cesta, nie exportovaný E2E postup. Referencie bez postupu: {absent}; na kontrolu: {review}; neaktuálne: {obsolete}. Príprava všetkých predpokladov je externá; dáta sa nevytvárajú.",
  "test-scenario.e2e.unresolved": "Externá alebo neurčená referencia. Zdrojový TC postup nie je k dispozícii.",
  "test-scenario.fixture.caller": "Prihlásený používateľ",
  "test-scenario.fixture.user.first-name": "Meno",
  "test-scenario.fixture.user.last-name": "Priezvisko",
  "test-scenario.fixture.user.username": "Používateľské meno",
  "test-scenario.identity-conflict": "Rozpor s maticou",
  "test-scenario.no-prerequisites": "Scenár {code} nevyžaduje prípravu dát.",
  "test-scenario.panel.minimize": "Minimalizovať",
  "test-scenario.panel.move": "Panel presuniete potiahnutím hlavičky.",
  "test-scenario.panel.restore": "Obnoviť",
  "test-scenario.panel.title": "Testovacie scenáre",
  "test-scenario.preparation.external": "externá – dáta si pripravte sami",
  "test-scenario.preparation.local": "lokálna",
  "test-scenario.preparation.none": "nie je potrebná",
  "test-scenario.prepare": "Začať scenár",
  "test-scenario.prepare-error": "Príprava scenára {code} zlyhala. Môžete ju skúsiť znova.",
  "test-scenario.prepare-label": "Začať scenár {code}",
  "test-scenario.prepared": "Scenár {code}: lokálne pripravené záznamy {count}.",
  "test-scenario.ris-file.hint": "Voliteľné. Spisová značka vlastného spisu založeného v RIS (test), ktorého spracovateľom ste vy; príprava ho použije namiesto fiktívneho spisu. Bez čísla sa vytvorí fiktívny spis.",
  "test-scenario.ris-file.hint-required": "Povinné – kroky scenára zakladajú záznamy, synchronizujú spis alebo pracujú v RIS, čo na fiktívnom spise neprejde. Zadajte spisovú značku nového spisu založeného v RIS (test), ktorého spracovateľom ste vy (prihlásený používateľ); príprava ho použije pre prípad a každý spis možno použiť iba raz.",
  "test-scenario.ris-file.label": "Číslo spisu v RIS",
  "test-scenario.ris-file.label-required": "Číslo spisu v RIS (povinné)",
  "test-scenario.ris-file.required-tooltip": "Najprv zadajte číslo spisu v RIS.",
  "test-scenario.started": "Scenár {code} bol otvorený.",

  "tools.menu.title": "Nástroje",

  "upvs-form.menu.title": "UPVS formuláre",

  "user.menu.title": "Používatelia",

  "validation/array.exact": "Musí obsahovať presne {value} položiek",
  "validation/array.too_big.exclusive": "Musí obsahovať menej ako {value, plural, =1 {jednu položku} other {# položiek}}",
  "validation/array.too_big.inclusive": "Musí obsahovať najviac {value, plural, =1 {jednu položku} other {# položiek}}",
  "validation/array.too_small.exclusive": "Musí obsahovať viac ako {value, plural, =1 {jednu položku} other {# položiek}}",
  "validation/array.too_small.inclusive": "Musí obsahovať aspoň {value, plural, =1 {jednu položku} other {# položiek}}",
  "validation/date.exact": "Musí byť presne {value}",
  "validation/date.invalid_date": "Neplatný dátum",
  "validation/date.too_big.exclusive": "Musí byť pred {value}",
  "validation/date.too_big.inclusive": "Musí byť najneskôr {value}",
  "validation/date.too_small.exclusive": "Musí byť po {value}",
  "validation/date.too_small.inclusive": "Musí byť najskôr {value}",
  "validation/default": "Neplatný vstup",
  "validation/file.required": "Povinné pole",
  "validation/number.exact": "Musí byť presne {value}",
  "validation/number.not_multiple_of": "Musí byť násobkom čísla {value}",
  "validation/number.too_big.exclusive": "Musí byť menšie ako {value}",
  "validation/number.too_big.inclusive": "Musí byť najviac {value}",
  "validation/number.too_small.exclusive": "Musí byť väčšie ako {value}",
  "validation/number.too_small.inclusive": "Musí byť aspoň {value}",
  "validation/string.exact": "Musí obsahovať presne {value} znakov",
  "validation/string.invalid.datetime": "Neplatný dátum",
  "validation/string.invalid.email": "Neplatná e-mailová adresa",
  "validation/string.invalid.endsWith": "Musí končiť na {value}",
  "validation/string.invalid.regex": "Neplatný formát",
  "validation/string.invalid.startsWith": "Musí začínať na {value}",
  "validation/string.invalid.url": "Neplatná adresa URL",
  "validation/string.required": "Povinné pole",
  "validation/string.too_big.exclusive": "Musí obsahovať menej ako {value, plural, =1 {jeden znak} other {# znakov}}",
  "validation/string.too_big.inclusive": "Musí obsahovať najviac {value, plural, =1 {jeden znak} other {# znakov}}",
  "validation/string.too_small.exclusive": "Musí obsahovať viac ako {value, plural, =1 {jeden znak} other {# znakov}}",
  "validation/string.too_small.inclusive": "Musí obsahovať aspoň {value, plural, =1 {jeden znak} other {# znakov}}",
  "validation/type.invalid": "Neplatný typ. Očakávané: \"{expected}\", prijaté: \"{received}\"",
  "validation/type.required": "Povinné pole"
}
